'use client'
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/context/ImaginationRoom.tsx
import { createContext, useContext, useState as useState6, useEffect as useEffect2 } from "react";
import canUseDOM6 from "@invitato/helpers/dist/canUseDOM";

// src/usecase/use-color-simulation/useColorSimulation.ts
import { useState } from "react";

// src/model/imagination-room/constants.ts
var SS_KEY = {
  extractedColor: "extractedColor",
  colorPalette: "colorPallete",
  currentColor: "currentColor",
  imageToExtract: "imageToExtract",
  imageSimulation: "imageSimulation",
  fontSimulation: "fontSimulation",
  coupleData: "coupleData"
};
var DRAWER_STATE = {
  idle: "idle",
  transitioning: "transitioning",
  color: "color",
  image: "image",
  font: "font",
  config: "config"
};

// src/utils/session/set.ts
import canUseDOM from "@invitato/helpers/dist/canUseDOM";
function setSessionItem(KEY, value) {
  try {
    if (canUseDOM) {
      sessionStorage.setItem(KEY, value);
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}

// src/utils/session/get.ts
import { canUseDOM as canUseDOM2 } from "@invitato/helpers";
function getSessionItem(KEY) {
  try {
    if (canUseDOM2) {
      const result = sessionStorage.getItem(KEY);
      return result;
    }
    return void 0;
  } catch (e) {
    return void 0;
  }
}

// src/utils/session/safeParse.ts
function safeParse(jsonString, fallback) {
  try {
    if (!jsonString) {
      return fallback;
    }
    return JSON.parse(jsonString);
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return fallback;
  }
}

// src/utils/color/useUpdateColor.ts
import { canUseDOM as canUseDOM3 } from "@invitato/helpers";
function useUpdateColor(colorCSS, colorValue) {
  try {
    if (canUseDOM3) {
      document.documentElement.style.setProperty(`--chakra-colors-${colorCSS}`, colorValue);
    }
    return;
  } catch (e) {
    return;
  }
}
var useUpdateColor_default = useUpdateColor;

// src/utils/color/getColorSession.ts
function getColorSession(fallback, isEnableImaginationRoom) {
  const colorData = safeParse(
    getSessionItem(SS_KEY.currentColor),
    fallback
  );
  if (isEnableImaginationRoom && colorData && colorData.length !== 0) {
    colorData.forEach(({ colorCSS, colorValue }) => {
      useUpdateColor_default(colorCSS, colorValue);
    });
    return colorData;
  }
  return fallback;
}
var getColorSession_default = getColorSession;

// src/utils/color/getExtractedColorSession.ts
function getExtractedColorSession(isEnableImaginationRoom) {
  if (isEnableImaginationRoom) {
    const extractedColorData = safeParse(
      getSessionItem(SS_KEY.extractedColor),
      []
    );
    if (extractedColorData && extractedColorData.length !== 0) {
      return extractedColorData;
    }
    return [];
  }
  return [];
}
var getExtractedColorSession_default = getExtractedColorSession;

// src/utils/color/getPaletteSession.ts
function getPaletteSession(isEnableImaginationRoom) {
  if (isEnableImaginationRoom) {
    const paletteData = safeParse(
      getSessionItem(SS_KEY.colorPalette),
      []
    );
    if (paletteData && paletteData.length !== 0) {
      return paletteData;
    }
    return [];
  }
  return [];
}
var getPaletteSession_default = getPaletteSession;

// src/usecase/use-color-simulation/useColorSimulation.ts
function useColorSimulation({
  isEnableImaginationRoom,
  defaultColor
}) {
  const [extractedColor, setExtractedColor] = useState(
    getExtractedColorSession_default(isEnableImaginationRoom)
  );
  const [colorPalette, setColorPalette] = useState(getPaletteSession_default(isEnableImaginationRoom));
  const [colorForm, setColorForm] = useState(
    getColorSession_default(defaultColor, isEnableImaginationRoom)
  );
  const handleSetColor = (colorCSS, colorValue) => {
    if (isEnableImaginationRoom) {
      const updatedFields = colorForm.map(
        (field) => field.colorCSS === colorCSS ? __spreadProps(__spreadValues({}, field), { colorValue }) : field
      );
      setColorForm(updatedFields);
      useUpdateColor_default(colorCSS, colorValue);
      setSessionItem(SS_KEY.currentColor, JSON.stringify(updatedFields));
    }
  };
  const handleLoadColor = (form) => {
    if (isEnableImaginationRoom) {
      setColorForm(form);
      form.forEach(({ colorCSS, colorValue }) => {
        useUpdateColor_default(colorCSS, colorValue);
      });
      setSessionItem(SS_KEY.currentColor, JSON.stringify(form));
    }
  };
  const handleResetSingleColor = (colorCSS) => {
    var _a;
    const colorPayload = (_a = defaultColor.find(
      (field) => field.colorCSS === colorCSS
    )) == null ? void 0 : _a.colorValue;
    if (colorPayload) {
      const updatedFields = colorForm.map(
        (field) => field.colorCSS === colorCSS ? __spreadProps(__spreadValues({}, field), { colorValue: colorPayload }) : field
      );
      setColorForm(updatedFields);
      useUpdateColor_default(colorCSS, colorPayload);
      setSessionItem(SS_KEY.currentColor, JSON.stringify(updatedFields));
    }
  };
  const handleResetColor = () => {
    handleLoadColor(defaultColor);
    defaultColor.forEach(({ colorCSS, colorValue }) => {
      useUpdateColor_default(colorCSS, colorValue);
    });
  };
  return {
    extractedColor,
    colorPalette,
    colorForm,
    onSetExtractedColor: setExtractedColor,
    onSetColorPalette: setColorPalette,
    onSetColor: handleSetColor,
    onHandleResetSingleColor: handleResetSingleColor,
    onHandleResetColor: handleResetColor,
    onHandleLoadColor: handleLoadColor
  };
}
var useColorSimulation_default = useColorSimulation;

// src/usecase/use-image-simulation/useImageSimulation.ts
import { useState as useState2 } from "react";

// src/utils/image/getImageSession.ts
function getImageSession(fallback) {
  const imageData = safeParse(
    getSessionItem(SS_KEY.imageSimulation),
    fallback
  );
  if (imageData && imageData.length !== 0) {
    return imageData;
  }
  return fallback;
}
var getImageSession_default = getImageSession;

// src/usecase/use-image-simulation/useImageSimulation.ts
function useImageSimulation({
  isEnableImaginationRoom,
  defaultImages
}) {
  const [imageForm, setImageForm] = useState2(getImageSession_default(defaultImages));
  const handleSetImage = (imageConstant, imageValue) => {
    if (isEnableImaginationRoom) {
      const updatedFields = imageForm.map(
        (field) => field.imageConstant === imageConstant ? __spreadProps(__spreadValues({}, field), { imageValue }) : field
      );
      setImageForm(updatedFields);
      setSessionItem(SS_KEY.imageSimulation, JSON.stringify(updatedFields));
    }
  };
  const handleLoadImage = (form) => {
    if (isEnableImaginationRoom) {
      setImageForm(form);
      setSessionItem(SS_KEY.imageSimulation, JSON.stringify(form));
    }
  };
  const handleResetImage = () => {
    setImageForm(defaultImages);
  };
  const handleSaveImage = () => {
    setSessionItem(SS_KEY.imageSimulation, JSON.stringify(imageForm));
  };
  const getFinalContent = (keyContent, fallback) => {
    if (isEnableImaginationRoom) {
      const image = imageForm.find((item) => item.imageConstant === keyContent);
      return image ? image.imageValue || fallback : fallback;
    }
    return fallback;
  };
  return {
    imageForm,
    onSetImage: handleSetImage,
    onGetFinalContent: getFinalContent,
    onHandleResetImage: handleResetImage,
    onHandleSaveImage: handleSaveImage,
    onHandleLoadImage: handleLoadImage
  };
}
var useImageSimulation_default = useImageSimulation;

// src/usecase/use-font-simulation/useFontSimulation.ts
import { useState as useState4 } from "react";

// src/utils/font/useUpdateFonts.ts
import { canUseDOM as canUseDOM4 } from "@invitato/helpers";
function useUpdateFonts(fontData) {
  try {
    if (canUseDOM4) {
      const { fontCSS, fontFamilyValue, fontSizeValue, fontWeightValue, isFontItalic } = fontData;
      document.documentElement.style.setProperty(`--chakra-fonts-${fontCSS}`, fontFamilyValue);
      document.documentElement.style.setProperty(
        `--chakra-fontSizes-${fontCSS}`,
        `${fontSizeValue}px`
      );
      document.documentElement.style.setProperty(
        `--chakra-fontWeights-${fontCSS}`,
        fontWeightValue
      );
      if (isFontItalic) {
        document.documentElement.style.setProperty(`--fontItalic-${fontCSS}`, "italic");
      } else {
        document.documentElement.style.setProperty(`--fontItalic-${fontCSS}`, "normal");
      }
      return;
    }
  } catch (e) {
    return;
  }
}
var useUpdateFonts_default = useUpdateFonts;

// src/utils/font/getFontSession.ts
function getFontSession(fallback, isEnableImaginationRoom) {
  const fontData = safeParse(
    getSessionItem(SS_KEY.fontSimulation),
    fallback
  );
  if (isEnableImaginationRoom && fontData && fontData.length !== 0) {
    fontData.forEach((data) => {
      useUpdateFonts_default(data);
    });
    return fontData;
  }
  return fallback;
}
var getFontSession_default = getFontSession;

// src/utils/font/loadGoogleFont.ts
import { canUseDOM as canUseDOM5 } from "@invitato/helpers";
var loadGoogleFont = (fontFamily) => {
  try {
    if (canUseDOM5) {
      const linkId = `google-font-${fontFamily}`;
      if (document.getElementById(linkId)) {
        return;
      }
      const link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      link.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(
        / /g,
        "+"
      )}&display=swap`;
      document.head.appendChild(link);
    }
    return;
  } catch (e) {
    return;
  }
};
var loadGoogleFont_default = loadGoogleFont;

// src/utils/font/useDebounce.ts
import { useState as useState3, useEffect } from "react";
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState3(value);
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
    // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}
var useDebounce_default = useDebounce;

// src/usecase/use-font-simulation/use-get-font-list/useGetFontList.ts
import { useMemo } from "react";
import useSWRImmutable from "swr/immutable";

// src/model/font/constants.ts
var FONT_API_URL = "https://invitato.id/api/fonts";
var FONT_SIZES = [
  "6",
  "8",
  "10",
  "12",
  "14",
  "16",
  "18",
  "21",
  "24",
  "28",
  "32",
  "36",
  "42",
  "48",
  "56",
  "64",
  "72",
  "80",
  "88",
  "96",
  "104",
  "120",
  "144"
];

// src/utils/swr/fetcher.ts
var fetcher = (url) => fetch(url).then((res) => res.json());

// src/usecase/use-font-simulation/use-get-font-list/useGetFontList.ts
function useGetFontList(isEnableImaginationRoom) {
  const { data, isLoading } = useSWRImmutable(
    isEnableImaginationRoom ? FONT_API_URL + `?type=FONT_LIST` : null,
    fetcher
  );
  const normalizeData = useMemo(() => {
    if (!(data == null ? void 0 : data.success)) return [];
    if (((data == null ? void 0 : data.data) || []).length === 0) return [];
    return (data.data || []).map((item) => {
      return {
        family: item.FONT_FAMILY,
        variants: item.VARIANTS.map((variant) => String(variant))
      };
    });
  }, [data == null ? void 0 : data.data, data == null ? void 0 : data.success]);
  return { isFontListLoading: isLoading, fontList: normalizeData };
}
var useGetFontList_default = useGetFontList;

// src/usecase/use-font-simulation/use-get-font-recommendation/useGetFontRecommendation.ts
import { useMemo as useMemo2 } from "react";
import useSWRImmutable2 from "swr/immutable";
var DEFAULT_EMPTY_FONT_RECOMMENDATION = {
  heading_font: [],
  sub_heading_font: [],
  body_font: []
};
function useGetFontRecommendation(isEnableImaginationRoom) {
  const { data, isLoading } = useSWRImmutable2(
    isEnableImaginationRoom ? FONT_API_URL + `?type=FONT_RECOMMENDATION` : null,
    fetcher
  );
  const normalizeData = useMemo2(() => {
    var _a, _b, _c, _d;
    if (!(data == null ? void 0 : data.success)) return DEFAULT_EMPTY_FONT_RECOMMENDATION;
    if ((((_a = data.data) == null ? void 0 : _a.HEADING_FONT) || []).length === 0) return DEFAULT_EMPTY_FONT_RECOMMENDATION;
    return {
      heading_font: ((_b = data.data) == null ? void 0 : _b.HEADING_FONT) || [],
      sub_heading_font: ((_c = data.data) == null ? void 0 : _c.SUB_HEADING_FONT) || [],
      body_font: ((_d = data.data) == null ? void 0 : _d.BODY_FONT) || []
    };
  }, [data == null ? void 0 : data.data, data == null ? void 0 : data.success]);
  return {
    isFontRecommendationLoading: isLoading,
    fontRecommendation: normalizeData
  };
}
var useGetFontRecommendation_default = useGetFontRecommendation;

// src/usecase/use-font-simulation/useFontSimulation.ts
function useFontSimulation({
  isEnableImaginationRoom,
  defaultFontData
}) {
  const [fontForm, setFontForm] = useState4(
    getFontSession_default(defaultFontData, isEnableImaginationRoom)
  );
  const { fontList, isFontListLoading } = useGetFontList_default(isEnableImaginationRoom);
  const { fontRecommendation, isFontRecommendationLoading } = useGetFontRecommendation_default(isEnableImaginationRoom);
  const handleSetFont = (fontData) => {
    if (isEnableImaginationRoom) {
      const { fontCSS, fontFamilyValue, fontSizeValue, fontWeightValue, isFontItalic } = fontData;
      const updatedFields = fontForm.map(
        (field) => field.fontCSS === fontCSS ? __spreadProps(__spreadValues({}, field), {
          fontFamilyValue,
          fontWeightValue,
          fontSizeValue: `${fontSizeValue}`,
          isFontItalic
        }) : field
      );
      setFontForm(updatedFields);
      useUpdateFonts_default(fontData);
      setSessionItem(SS_KEY.fontSimulation, JSON.stringify(updatedFields));
    }
  };
  const handleLoadFont = (form) => {
    if (isEnableImaginationRoom) {
      setFontForm(form);
      form.forEach((fontData) => {
        useUpdateFonts_default(fontData);
      });
      setSessionItem(SS_KEY.fontSimulation, JSON.stringify(form));
    }
  };
  const handleResetFont = () => {
    handleLoadFont(defaultFontData);
    defaultFontData.forEach((fontData) => {
      useUpdateFonts_default(fontData);
    });
  };
  return {
    fontForm,
    fontList,
    fontRecommendation,
    isFontListLoading,
    isFontRecommendationLoading,
    onSetFont: handleSetFont,
    onHandleResetFont: handleResetFont,
    onHandleLoadFont: handleLoadFont
  };
}
var useFontSimulation_default = useFontSimulation;

// src/usecase/use-couple-simulation/useCoupleSimulation.ts
import { useState as useState5 } from "react";

// src/utils/couple/getCoupleSession.ts
function getCoupleSession(fallback) {
  const fontData = safeParse(
    getSessionItem(SS_KEY.coupleData),
    fallback
  );
  if (fontData) {
    return fontData;
  }
  return fallback;
}
var getCoupleSession_default = getCoupleSession;

// src/usecase/use-couple-simulation/useCoupleSimulation.ts
function useCoupleSimulation({
  isEnableImaginationRoom,
  defaultCoupleData
}) {
  const [coupleForm, setCoupleForm] = useState5(getCoupleSession_default(defaultCoupleData));
  const handleSetCouple = (updatedFields) => {
    setCoupleForm(updatedFields);
    setSessionItem(SS_KEY.coupleData, JSON.stringify(updatedFields));
  };
  const handleLoadCouple = (form) => {
    setCoupleForm(form);
    setSessionItem(SS_KEY.coupleData, JSON.stringify(form));
  };
  const handleResetCouple = () => {
    handleLoadCouple(defaultCoupleData);
  };
  const getFinalName = (keyContent, fallback) => {
    if (isEnableImaginationRoom) {
      return coupleForm[keyContent];
    }
    return fallback;
  };
  return {
    coupleForm,
    onSetCouple: handleSetCouple,
    onGetFinalName: getFinalName,
    onHandleResetCouple: handleResetCouple,
    onHandleLoadCouple: handleLoadCouple
  };
}
var useCoupleSimulation_default = useCoupleSimulation;

// src/context/ImaginationRoom.tsx
import { jsx } from "react/jsx-runtime";
var ImaginationRoomContext = createContext(
  {}
);
function ImaginationRoomProvider({
  children,
  isEnabled,
  defaultColor,
  defaultImages,
  defaultFontData,
  defaultCoupleData
}) {
  const [currentFile, setCurrentFile] = useState6("");
  const [isImporting, setIsImporting] = useState6(false);
  const [isEnableImaginationRoom, setIsEnableImaginationRoom] = useState6(false);
  useEffect2(() => {
    if (canUseDOM6 && isEnabled) {
      const url = window.location.href;
      setIsEnableImaginationRoom(url.includes("https://invitato.net/template-"));
    }
  }, [isEnabled]);
  const _a = useColorSimulation_default({
    isEnableImaginationRoom,
    defaultColor
  }), { colorForm } = _a, colorSimulation = __objRest(_a, ["colorForm"]);
  const _b = useImageSimulation_default({
    isEnableImaginationRoom,
    defaultImages
  }), { imageForm } = _b, imageSimulation = __objRest(_b, ["imageForm"]);
  const _c = useFontSimulation_default({
    isEnableImaginationRoom,
    defaultFontData
  }), { fontForm } = _c, fontSimulation = __objRest(_c, ["fontForm"]);
  const _d = useCoupleSimulation_default({
    isEnableImaginationRoom,
    defaultCoupleData
  }), { coupleForm } = _d, coupleSimulation = __objRest(_d, ["coupleForm"]);
  return /* @__PURE__ */ jsx(
    ImaginationRoomContext.Provider,
    {
      value: __spreadValues(__spreadValues(__spreadValues(__spreadValues({
        colorForm,
        imageForm,
        fontForm,
        coupleForm,
        currentFile,
        isImporting,
        onSetCurrentFile: setCurrentFile,
        onSetIsImporting: setIsImporting,
        isEnableImaginationRoom
      }, colorSimulation), imageSimulation), fontSimulation), coupleSimulation),
      children
    }
  );
}
var useImaginationRoom = () => {
  const context = useContext(ImaginationRoomContext);
  if (typeof context === "undefined") {
    throw new Error("useImaginationRoom() should be used inside <ImaginationRoomContext />");
  }
  return context;
};

// src/components/SimulationDrawer.tsx
import { useState as useState16 } from "react";
import {
  useDisclosure as useDisclosure9,
  Slide,
  Box as Box18,
  Collapse,
  Portal,
  Button as Button15,
  Center as Center8,
  CloseButton as CloseButton2
} from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { LuPalette, LuImage, LuDownload as LuDownload2, LuText } from "react-icons/lu";

// src/components/styles.ts
var DEFAULT_BOX_PROPS = {
  p: "12px 12px",
  bg: "rgb(250, 248, 244)",
  justifyContent: "space-evenly",
  position: "relative",
  border: "1px solid #dee2e6"
};
var SIMULATION_BUTTON_PRIMARY = {
  p: "0 18px",
  bg: "#ba5c76",
  color: "white",
  size: "sm",
  fontFamily: "poppins",
  borderRadius: "2xl",
  _hover: { bgColor: "#a1425c" }
};
var SIMULATION_BUTTON_SECONDARY = {
  p: "0 18px",
  bg: "transparent",
  color: "#ba5c76",
  size: "sm",
  fontFamily: "poppins",
  borderRadius: "2xl",
  _hover: { bgColor: "rgba(183, 82, 109, 0.12)" }
};
var SIMULATION_BUTTON_ALTERNATIVE = {
  p: "0 18px",
  bg: "transparent",
  color: "#ba5c76",
  size: "sm",
  fontFamily: "poppins",
  borderRadius: "2xl",
  bgColor: "rgba(183, 82, 109, 0.1)",
  _hover: { bgColor: "rgba(183, 82, 109, 0.12)" }
};
var SIMULATION_CONTAINER_PROPS = {
  position: "relative",
  borderTopRadius: "md"
};
var SIMULATION_HEADER_CONTAINER = {
  p: "30px 16px 14px",
  bg: "rgb(250, 248, 244)",
  zIndex: 3,
  borderBottom: "1px solid #dee2e6",
  borderTopRadius: "xl",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: "600"
};
var SIMULATION_HEADER_TEXT = {
  size: "md",
  fontWeight: "500",
  fontFamily: "poppins"
};
var SIMULATION_SUBTITLE_TEXT = {
  fontSize: "0.75rem",
  fontWeight: "400",
  fontFamily: "poppins",
  textAlign: "center",
  fontStyle: "italic"
};
var SIMULATION_BODY_CONTAINER = {
  px: "12px",
  overflow: "auto",
  pb: "12px",
  h: "438px"
};

// src/components/common/ImageDrop/ImageDrop.tsx
import {
  useMemo as useMemo3,
  useState as useState7,
  useRef
} from "react";
import {
  Box as Box2,
  Button,
  Text as Text2,
  Center,
  useToast,
  CircularProgress,
  CircularProgressLabel
} from "@chakra-ui/react";
import { LuImagePlus, LuPencil } from "react-icons/lu";
import imageCompression from "browser-image-compression";

// src/model/simulation-drawer/constants.ts
var IMAGE_SUPPORTED_FILE_TYPES = ["image/png", "image/jpeg", "image/webp"];

// src/components/common/CustomToast/CustomToast.tsx
import { Box, CloseButton, Text } from "@chakra-ui/react";
import { LuAlertCircle, LuAlertTriangle, LuCheckCircle } from "react-icons/lu";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var getIcon = (status) => {
  switch (status) {
    case "success":
      return /* @__PURE__ */ jsx2(LuCheckCircle, { color: "#fff", size: 20 });
    case "error":
      return /* @__PURE__ */ jsx2(LuAlertTriangle, { color: "#fff", size: 20 });
    case "info":
      return /* @__PURE__ */ jsx2(LuAlertCircle, { color: "#fff", size: 20 });
    default:
      return /* @__PURE__ */ jsx2(LuAlertTriangle, { color: "#fff", size: 20 });
  }
};
var getBackground = (status) => {
  switch (status) {
    case "success":
      return "#2F855A";
    case "error":
      return "rgb(250, 82, 82)";
    case "info":
      return "#a1425c";
    default:
      return "rgb(250, 82, 82)";
  }
};
function CustomToast({ title, children, desc, status = "error", onClose, id }) {
  return /* @__PURE__ */ jsx2(Box, { p: "8px 32px", children: /* @__PURE__ */ jsxs(
    Box,
    {
      w: "100%",
      maxW: "384px",
      h: "100%",
      minH: "72px",
      p: "16px",
      pr: "32px",
      bg: getBackground(status),
      pos: "relative",
      id: String(id),
      borderRadius: "0.375rem",
      children: [
        /* @__PURE__ */ jsx2(
          CloseButton,
          {
            color: "#fff",
            size: "sm",
            pos: "absolute",
            right: "0.25rem",
            top: "0.25rem",
            onClick: onClose
          }
        ),
        /* @__PURE__ */ jsxs(Box, { display: "flex", children: [
          /* @__PURE__ */ jsx2(Box, { ml: "0", mr: "12px", children: getIcon(status) }),
          /* @__PURE__ */ jsxs(Box, { mt: "-4px", children: [
            /* @__PURE__ */ jsx2(Text, __spreadProps(__spreadValues({}, SIMULATION_HEADER_TEXT), { color: "#fff", fontSize: "0.875rem", children: title })),
            /* @__PURE__ */ jsxs(Box, { children: [
              /* @__PURE__ */ jsx2(
                Text,
                __spreadProps(__spreadValues({}, SIMULATION_SUBTITLE_TEXT), {
                  p: "0",
                  fontStyle: "normal",
                  textAlign: "left",
                  color: "#fff",
                  mb: "4px",
                  children: desc
                })
              ),
              children
            ] })
          ] })
        ] })
      ]
    }
  ) });
}
var CustomToast_default = CustomToast;

// src/components/common/ImageDrop/ImageDrop.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var ImageDrop = ({
  imageName,
  imageConstant,
  imageObject,
  onChange
}) => {
  const { isImporting, onSetIsImporting } = useImaginationRoom();
  const [image, setImage] = useState7(imageObject || null);
  const [isLoading, setIsLoading] = useState7(false);
  const [progressValue, setProgressValue] = useState7(0);
  const fileInputRef = useRef(null);
  const toast = useToast();
  const controllerRef = useRef(new AbortController());
  useMemo3(() => {
    setImage(imageObject || null);
  }, [imageObject]);
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleFileInputChange = (e) => {
    var _a;
    const file = (_a = e.target.files) == null ? void 0 : _a[0];
    if (file) {
      handleFile(file);
    }
  };
  const handleFile = (file) => __async(void 0, null, function* () {
    if (isImporting) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose, id }) => /* @__PURE__ */ jsx3(
          CustomToast_default,
          {
            status: "info",
            title: "Tunggu...",
            desc: "Silakan tunggu file lain yang sedang loading terlebih dahulu.",
            id,
            onClose
          }
        )
      });
      return;
    }
    if (!IMAGE_SUPPORTED_FILE_TYPES.includes(file.type)) {
      toast({
        title: "File tidak didukung.",
        description: "Silakan convert gambar HEIC/HEIF menjadi JPG, JPEG, atau PNG terlebih dahulu.",
        status: "warning",
        duration: 9e3,
        isClosable: true
      });
      return;
    }
    setIsLoading(true);
    onSetIsImporting(true);
    controllerRef.current = new AbortController();
    let processedFile = file;
    const options = {
      maxSizeMB: 0.9,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
      onProgress: (progress) => setProgressValue(progress),
      signal: controllerRef.current.signal
    };
    try {
      if (file.size / 1024 / 1024 > 1) {
        processedFile = yield imageCompression(file, options);
      }
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;
        setImage(base64String);
        onChange(imageConstant, base64String);
        setProgressValue(0);
        setIsLoading(false);
        onSetIsImporting(false);
      };
      reader.readAsDataURL(processedFile);
    } catch (error) {
      if (error instanceof Error) {
        if (error.name === "AbortError") {
          toast({
            position: "top",
            duration: 5e3,
            render: ({ onClose, id }) => /* @__PURE__ */ jsx3(
              CustomToast_default,
              {
                status: "info",
                title: "Sukses!",
                desc: "Berhasil membatalkan import foto.",
                id,
                onClose
              }
            )
          });
        }
        setProgressValue(0);
        setIsLoading(false);
        onSetIsImporting(false);
      }
    }
  });
  const abortImportImage = (e) => {
    e.stopPropagation();
    if (!controllerRef.current) return;
    controllerRef.current.abort();
  };
  return /* @__PURE__ */ jsxs2(
    Box2,
    {
      pos: "relative",
      zIndex: "2",
      display: "flex",
      flexDirection: "column",
      p: "12px 0 8px",
      children: [
        /* @__PURE__ */ jsxs2(
          Box2,
          {
            border: image ? "1px solid #55555526" : "2px dashed #55555526",
            color: "black",
            height: "150px",
            width: "100%",
            bgColor: image ? "" : "rgba(245,236,238, 0.2)",
            onDrop: handleDrop,
            onDragOver: handleDragOver,
            onClick: () => {
              var _a;
              return (_a = fileInputRef.current) == null ? void 0 : _a.click();
            },
            style: { cursor: "pointer", borderRadius: "8px" },
            py: "4px",
            position: "relative",
            children: [
              /* @__PURE__ */ jsx3(
                "input",
                {
                  type: "file",
                  accept: "image/*",
                  style: { display: "none" },
                  ref: fileInputRef,
                  onChange: handleFileInputChange
                }
              ),
              isLoading ? /* @__PURE__ */ jsxs2(Box2, { display: "flex", flexDir: "column", mt: "36px", children: [
                /* @__PURE__ */ jsx3(Center, { children: /* @__PURE__ */ jsx3(
                  CircularProgress,
                  {
                    value: progressValue || 0,
                    color: "#a1425c",
                    size: "48px",
                    children: /* @__PURE__ */ jsx3(CircularProgressLabel, { children: `${progressValue}%` })
                  }
                ) }),
                /* @__PURE__ */ jsx3(
                  Button,
                  {
                    alignSelf: "center",
                    justifySelf: "center",
                    mt: "12px",
                    variant: "outline",
                    w: "fit-content",
                    size: "sm",
                    fontFamily: "poppins",
                    color: "#a1425c",
                    borderColor: "#a1425c",
                    zIndex: 1e3,
                    onClick: (e) => abortImportImage(e),
                    children: "Batalkan"
                  }
                )
              ] }) : /* @__PURE__ */ jsx3(Fragment, { children: image ? /* @__PURE__ */ jsxs2(Fragment, { children: [
                /* @__PURE__ */ jsx3(
                  "img",
                  {
                    src: image,
                    alt: "Dropped",
                    style: {
                      width: "100%",
                      height: "100%",
                      objectFit: "contain"
                    }
                  }
                ),
                /* @__PURE__ */ jsx3(
                  Box2,
                  {
                    pos: "absolute",
                    top: "8px",
                    right: "8px",
                    border: "1px dashed #55555526",
                    bgColor: "rgba(245,236,238, 0.2)",
                    p: "8px",
                    borderRadius: "3px",
                    _hover: { background: "rgba(245,236,238, 0.8)" },
                    children: /* @__PURE__ */ jsx3(LuPencil, { size: 16, color: "#a1425c" })
                  }
                )
              ] }) : /* @__PURE__ */ jsxs2(Center, { flexDirection: "column", h: "100%", children: [
                /* @__PURE__ */ jsx3(LuImagePlus, { size: 36, color: "#a1425c" }),
                /* @__PURE__ */ jsx3(
                  Text2,
                  {
                    mt: "8px",
                    color: "#a1425c",
                    fontFamily: "poppins",
                    fontSize: "0.75rem",
                    children: "Klik atau drag & drop foto disini"
                  }
                )
              ] }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx3(
          Button,
          __spreadProps(__spreadValues({}, SIMULATION_BUTTON_PRIMARY), {
            mt: "6px",
            onClick: () => {
              var _a;
              return (_a = fileInputRef.current) == null ? void 0 : _a.click();
            },
            children: imageName
          })
        )
      ]
    }
  );
};
var ImageDrop_default = ImageDrop;

// src/components/common/DrawerButton/DrawerButton.tsx
import { Box as Box3 } from "@chakra-ui/react";
import { jsx as jsx4 } from "react/jsx-runtime";
function DrawerButton({
  currentState,
  buttonState,
  icon,
  onUpdate
}) {
  const isTrue = currentState === buttonState;
  return /* @__PURE__ */ jsx4(
    Box3,
    {
      p: "6px",
      borderRadius: "14px",
      as: "button",
      display: "flex",
      onClick: onUpdate,
      backgroundColor: isTrue ? "rgba(183, 82, 109, 0.12)" : "",
      _hover: { backgroundColor: isTrue ? "" : "rgba(183, 82, 109, 0.1)" },
      children: /* @__PURE__ */ jsx4(
        Box3,
        {
          p: "10px",
          borderRadius: "0.5rem",
          backgroundColor: isTrue ? "" : "rgba(183, 82, 109, 0.12)",
          _hover: { backgroundColor: isTrue ? "" : "rgba(183, 82, 109, 0.12)" },
          children: icon
        }
      )
    }
  );
}

// src/components/common/ConfirmationAlert/ConfirmationAlert.tsx
import {
  Button as Button2,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text as Text3
} from "@chakra-ui/react";
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
function ConfirmationAlert({
  isOpenAlert,
  onCloseAlert,
  onConfirm,
  title,
  children,
  desc,
  buttonIcon,
  buttonText
}) {
  return /* @__PURE__ */ jsxs3(Modal, { isOpen: isOpenAlert, onClose: onCloseAlert, size: "md", isCentered: true, children: [
    /* @__PURE__ */ jsx5(ModalOverlay, {}),
    /* @__PURE__ */ jsxs3(ModalContent, { mx: "5dvw", my: "5dvh", backgroundColor: "rgb(250, 248, 244)", children: [
      /* @__PURE__ */ jsxs3(ModalBody, __spreadProps(__spreadValues({}, SIMULATION_BODY_CONTAINER), { p: "16px 16px 0", children: [
        /* @__PURE__ */ jsx5(Text3, { fontFamily: "Poppins", fontSize: "18px", color: "rgb(161, 66, 92)", fontWeight: "600", children: title }),
        /* @__PURE__ */ jsx5(
          Text3,
          __spreadProps(__spreadValues({}, SIMULATION_SUBTITLE_TEXT), {
            fontSize: "14px",
            fontStyle: "normal",
            textAlign: "left",
            mt: "16px",
            dangerouslySetInnerHTML: { __html: desc || "" }
          })
        ),
        children
      ] })),
      /* @__PURE__ */ jsxs3(ModalFooter, { p: "16px", children: [
        /* @__PURE__ */ jsx5(
          Button2,
          {
            ml: "10px",
            p: "0 18px",
            color: "rgb(33, 37, 41)",
            size: "md",
            fontSize: "14px",
            lineHeight: "1",
            fontFamily: "poppins",
            h: "35px",
            borderRadius: "2xl",
            border: "0.5px solid rgb(206, 212, 218)",
            bgColor: "rgb(250, 248, 244)",
            _hover: { bgColor: "rgb(248, 249, 250)" },
            onClick: onCloseAlert,
            children: "Batalkan"
          }
        ),
        /* @__PURE__ */ jsx5(
          Button2,
          {
            ml: "10px",
            p: "0 18px",
            color: "white",
            size: "md",
            fontSize: "14px",
            lineHeight: "1",
            h: "35px",
            fontFamily: "poppins",
            borderRadius: "2xl",
            bgColor: "rgb(161, 66, 92)",
            onClick: onConfirm,
            _hover: { bgColor: "rgb(145, 57, 82)" },
            leftIcon: buttonIcon,
            children: buttonText ? buttonText : "Ya, saya yakin"
          }
        )
      ] })
    ] })
  ] });
}
var ConfirmationAlert_default = ConfirmationAlert;

// src/components/SimulationColor/SimulationColor.tsx
import { Box as Box7, Button as Button5, Divider as Divider3, Text as Text7, useDisclosure as useDisclosure2, useToast as useToast4 } from "@chakra-ui/react";
import { scroller } from "react-scroll";

// src/components/SimulationColor/ImageExtract/ImageExtract.tsx
import { useState as useState8 } from "react";
import { Box as Box4, Button as Button3, Divider, SimpleGrid, Text as Text4, Tooltip } from "@chakra-ui/react";
import { extractColors } from "extract-colors";
import { Fragment as Fragment2, jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var ImageExtract = () => {
  const { extractedColor, onSetExtractedColor } = useImaginationRoom();
  const [image, setImage] = useState8(
    getSessionItem(SS_KEY.imageToExtract) || null
  );
  const handleFile = (_, imageFile) => {
    setImage(imageFile);
    extractColors(imageFile, { distance: 0.07 }).then((value) => {
      const finalExtractedColor = value.map((color) => color.hex);
      onSetExtractedColor(finalExtractedColor);
      setSessionItem(SS_KEY.extractedColor, JSON.stringify(finalExtractedColor));
      setSessionItem(SS_KEY.imageToExtract, imageFile);
    }).catch(console.error);
  };
  const handleReset = () => {
    setImage(null);
    onSetExtractedColor([]);
    setSessionItem(SS_KEY.imageToExtract, "");
    setSessionItem(SS_KEY.extractedColor, JSON.stringify([]));
  };
  return /* @__PURE__ */ jsxs4(Fragment2, { children: [
    /* @__PURE__ */ jsx6(
      ImageDrop_default,
      {
        imageConstant: "imageExtract",
        imageName: "Unggah Foto",
        imageObject: image,
        onChange: handleFile
      }
    ),
    /* @__PURE__ */ jsx6(Text4, __spreadProps(__spreadValues({}, SIMULATION_SUBTITLE_TEXT), { children: "Unggah sample foto pre-wedding Anda untuk mendapatkan rekomendasi warna terbaik!" })),
    extractedColor.length > 0 && /* @__PURE__ */ jsxs4(Fragment2, { children: [
      /* @__PURE__ */ jsx6(Divider, { m: "8px 0 0" }),
      /* @__PURE__ */ jsxs4(Box4, { pos: "relative", padding: "6px", children: [
        /* @__PURE__ */ jsxs4(Box4, { display: "flex", mb: "10px", alignItems: "center", children: [
          /* @__PURE__ */ jsx6(Text4, { fontSize: "0.875rem", fontFamily: "poppins", fontWeight: 600, mr: "auto", ml: "0", children: "Rekomendasi Warna" }),
          /* @__PURE__ */ jsx6(
            Button3,
            __spreadProps(__spreadValues({}, SIMULATION_BUTTON_SECONDARY), {
              onClick: () => handleReset(),
              mr: "0",
              ml: "auto",
              children: "Reset"
            })
          )
        ] }),
        /* @__PURE__ */ jsx6(SimpleGrid, { columns: 6, gap: 2, pos: "relative", width: "100%", children: extractedColor.map((val) => /* @__PURE__ */ jsx6(Tooltip, { label: val, "aria-label": val, children: /* @__PURE__ */ jsx6(
          Box4,
          {
            h: "24px",
            w: "24px",
            borderRadius: "50%",
            bg: val,
            border: "1px solid var(--chakra-colors-blackAlpha-400)"
          }
        ) }, val)) })
      ] })
    ] })
  ] });
};
var ImageExtract_default = ImageExtract;

// src/components/SimulationColor/ColorPicker/ColorPicker.tsx
import { useState as useState9 } from "react";
import {
  Box as Box5,
  Button as Button4,
  Flex,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text as Text5,
  useDisclosure,
  useToast as useToast2
} from "@chakra-ui/react";
import { SketchPicker } from "react-color";
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var ColorPicker = ({
  colorName,
  colorCSS,
  color,
  onChange,
  onScrollTo
}) => {
  const [selectedColor, setSelectedColor] = useState9(color);
  const { isOpen, onClose, onToggle } = useDisclosure();
  const { colorPalette, extractedColor, onSetColorPalette } = useImaginationRoom();
  const toast = useToast2();
  const handleOnChange = (colorResult) => {
    const { rgb, hex } = colorResult;
    const finalValue = `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`;
    setSelectedColor(hex);
    onChange(colorCSS, finalValue);
    document.documentElement.style.setProperty(`--chakra-colors-${colorCSS}`, finalValue);
  };
  const finalPreset = [...extractedColor, ...colorPalette];
  const handleAddPalette = () => {
    if (colorPalette.includes(selectedColor)) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx7(
          CustomToast_default,
          {
            status: "error",
            title: "Oops!",
            desc: "Warna sudah ada didalam palette.",
            id,
            onClose: onClose2
          }
        )
      });
      return;
    }
    const updatedColorPalette = [...colorPalette, selectedColor];
    onSetColorPalette(updatedColorPalette);
    toast({
      position: "top",
      duration: 5e3,
      render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx7(
        CustomToast_default,
        {
          status: "success",
          title: "Sukses!",
          desc: "Berhasil menambahkan warna kedalam palette.",
          id,
          onClose: onClose2
        }
      )
    });
    onClose();
  };
  return /* @__PURE__ */ jsx7(Box5, { py: "8px", w: "100%", children: /* @__PURE__ */ jsxs5(Flex, { align: "center", w: "100%", justifyContent: "space-between", children: [
    /* @__PURE__ */ jsx7(Text5, { color: "black", fontFamily: `"Poppins", serif;`, fontWeight: "normal", fontSize: "0.8rem", children: colorName }),
    /* @__PURE__ */ jsxs5(
      Popover,
      {
        isOpen,
        closeOnBlur: true,
        isLazy: true,
        strategy: "fixed",
        placement: "auto",
        onClose,
        children: [
          /* @__PURE__ */ jsx7(PopoverTrigger, { children: /* @__PURE__ */ jsx7(
            Button4,
            {
              onClick: () => onToggle(),
              shadow: "md",
              minW: "25px",
              h: "25px",
              border: "1px solid var(--chakra-colors-blackAlpha-600)",
              borderRadius: "50%",
              m: "0 3px 0 auto",
              p: "0",
              bg: `var(--chakra-colors-${colorCSS})`
            }
          ) }),
          /* @__PURE__ */ jsxs5(PopoverContent, { w: "fit-content", children: [
            /* @__PURE__ */ jsx7(
              SketchPicker,
              {
                presetColors: finalPreset,
                color,
                onChange: handleOnChange,
                width: "232px"
              }
            ),
            /* @__PURE__ */ jsx7(
              Button4,
              __spreadProps(__spreadValues({}, SIMULATION_BUTTON_ALTERNATIVE), {
                onClick: handleAddPalette,
                borderRadius: "none",
                fontSize: "14px",
                children: "+ Tambahkan ke palette"
              })
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx7(Button4, __spreadProps(__spreadValues({}, SIMULATION_BUTTON_ALTERNATIVE), { onClick: onScrollTo, children: "Lihat" }))
  ] }) });
};
var ColorPicker_default = ColorPicker;

// src/components/SimulationColor/ColorPalette/ColorPalette.tsx
import { Box as Box6, Divider as Divider2, SimpleGrid as SimpleGrid2, Text as Text6, Tooltip as Tooltip2, useToast as useToast3 } from "@chakra-ui/react";
import { LuX } from "react-icons/lu";
import { Fragment as Fragment3, jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var ColorPalette = () => {
  const { colorPalette, onSetColorPalette } = useImaginationRoom();
  const toast = useToast3();
  const handleDeletePalette = (paletteIndex) => {
    const updatedColorPalette = colorPalette.filter((_, index) => index !== paletteIndex);
    onSetColorPalette(updatedColorPalette);
    toast({
      position: "top",
      duration: 5e3,
      render: ({ onClose, id }) => /* @__PURE__ */ jsx8(
        CustomToast_default,
        {
          status: "success",
          title: "Sukses!",
          desc: "Berhasil menghapus warna dari palette.",
          id,
          onClose
        }
      )
    });
  };
  return /* @__PURE__ */ jsxs6(Fragment3, { children: [
    /* @__PURE__ */ jsx8(Divider2, { mt: "6px" }),
    /* @__PURE__ */ jsxs6(Box6, { pos: "relative", padding: "6px", children: [
      /* @__PURE__ */ jsx8(Text6, { fontSize: "0.875rem", fontFamily: "poppins", mb: "10px", fontWeight: 600, children: "Palette Warna" }),
      /* @__PURE__ */ jsx8(SimpleGrid2, { columns: 6, gap: 2, pos: "relative", width: "100%", children: colorPalette.map((val, index) => /* @__PURE__ */ jsx8(Tooltip2, { label: val, "aria-label": val, children: /* @__PURE__ */ jsx8(
        Box6,
        {
          h: "24px",
          w: "24px",
          borderRadius: "50%",
          bg: val,
          border: "1px solid var(--chakra-colors-blackAlpha-400)",
          pos: "relative",
          children: /* @__PURE__ */ jsx8(
            Box6,
            {
              pos: "absolute",
              top: "-9px",
              right: "-9px",
              borderRadius: "50%",
              p: "1px",
              zIndex: "2",
              bg: "rgb(226, 232, 240)",
              opacity: "60%",
              _hover: { opacity: "100%" },
              onClick: () => handleDeletePalette(index),
              children: /* @__PURE__ */ jsx8(LuX, { size: 14 })
            }
          )
        }
      ) }, val)) })
    ] })
  ] });
};
var ColorPalette_default = ColorPalette;

// src/components/SimulationColor/SimulationColor.tsx
import { Fragment as Fragment4, jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var SimulationColor = ({ isShowDetailContent }) => {
  const { colorForm, colorPalette, onSetColor, onHandleResetColor } = useImaginationRoom();
  const { isOpen: isOpenReset, onOpen: onOpenReset, onClose: onCloseReset } = useDisclosure2();
  const toast = useToast4();
  const onClickMenu = (idContent) => {
    if (!isShowDetailContent) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose, id }) => /* @__PURE__ */ jsx9(
          CustomToast_default,
          {
            status: "info",
            title: "Tunggu..",
            desc: "Buka undangan terlebih dahulu",
            id,
            onClose
          }
        )
      });
    }
    try {
      scroller.scrollTo(idContent, {
        duration: 1500,
        delay: 100,
        smooth: true
      });
    } catch (e) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose, id }) => /* @__PURE__ */ jsx9(
          CustomToast_default,
          {
            status: "error",
            title: "Oops!",
            desc: "Terjadi kesalahan. Mohon muat ulang browser Anda atau coba lagi nanti.",
            id,
            onClose
          }
        )
      });
    }
  };
  const onHandleReset = () => {
    try {
      onHandleResetColor();
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose, id }) => /* @__PURE__ */ jsx9(
          CustomToast_default,
          {
            status: "success",
            title: "Sukses!",
            desc: "List warna berhasil direset.",
            id,
            onClose
          }
        )
      });
    } catch (e) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose, id }) => /* @__PURE__ */ jsx9(
          CustomToast_default,
          {
            status: "error",
            title: "Oops!",
            desc: "Terjadi kesalahan. Mohon muat ulang browser Anda atau coba lagi nanti.",
            id,
            onClose
          }
        )
      });
    }
    onCloseReset();
  };
  return /* @__PURE__ */ jsxs7(Fragment4, { children: [
    /* @__PURE__ */ jsxs7(Box7, __spreadProps(__spreadValues({}, SIMULATION_CONTAINER_PROPS), { children: [
      /* @__PURE__ */ jsxs7(Box7, __spreadProps(__spreadValues({}, SIMULATION_HEADER_CONTAINER), { children: [
        /* @__PURE__ */ jsx9(Text7, __spreadProps(__spreadValues({}, SIMULATION_HEADER_TEXT), { children: "Simulasi Warna" })),
        /* @__PURE__ */ jsx9(Button5, __spreadProps(__spreadValues({}, SIMULATION_BUTTON_SECONDARY), { onClick: onOpenReset, children: "Reset Warna" }))
      ] })),
      /* @__PURE__ */ jsxs7(Box7, __spreadProps(__spreadValues({}, SIMULATION_BODY_CONTAINER), { children: [
        /* @__PURE__ */ jsx9(ImageExtract_default, {}),
        colorPalette.length > 0 && /* @__PURE__ */ jsx9(ColorPalette_default, {}),
        /* @__PURE__ */ jsx9(Divider3, { mt: "6px" }),
        colorForm.map(({ colorCSS, colorName, colorValue, colorSectionId }) => /* @__PURE__ */ jsx9(
          ColorPicker_default,
          {
            colorCSS,
            colorName,
            color: colorValue,
            onChange: (colorCSS2, newColorValue) => onSetColor(colorCSS2, newColorValue),
            onScrollTo: () => onClickMenu(colorSectionId)
          },
          colorCSS
        ))
      ] }))
    ] })),
    /* @__PURE__ */ jsx9(
      ConfirmationAlert_default,
      {
        isOpenAlert: isOpenReset,
        onCloseAlert: onCloseReset,
        onConfirm: onHandleReset,
        title: "Reset Warna",
        desc: "Apakah Anda yakin? Anda tidak dapat membatalkan tindakan ini setelahnya."
      }
    )
  ] });
};
var SimulationColor_default = SimulationColor;

// src/components/SimulationImage/SimulationImage.tsx
import { Box as Box8, Button as Button6, Link, Text as Text8, useDisclosure as useDisclosure3, useToast as useToast5 } from "@chakra-ui/react";
import { Fragment as Fragment5, jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var SimulationImage = ({ imageHelperLink, assetsHelperLink }) => {
  const { imageForm, onSetImage, onHandleResetImage } = useImaginationRoom();
  const { isOpen, onOpen, onClose } = useDisclosure3();
  const toast = useToast5();
  const onHandleReset = () => {
    try {
      onHandleResetImage();
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx10(
          CustomToast_default,
          {
            status: "success",
            title: "Sukses!",
            desc: "List foto berhasil direset.",
            id,
            onClose: onClose2
          }
        )
      });
    } catch (e) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx10(
          CustomToast_default,
          {
            status: "error",
            title: "Oops!",
            desc: "Terjadi kesalahan. Mohon muat ulang browser Anda atau coba lagi nanti.",
            id,
            onClose: onClose2
          }
        )
      });
    }
    onClose();
  };
  return /* @__PURE__ */ jsxs8(Fragment5, { children: [
    /* @__PURE__ */ jsxs8(Box8, __spreadProps(__spreadValues({}, SIMULATION_CONTAINER_PROPS), { children: [
      /* @__PURE__ */ jsxs8(Box8, __spreadProps(__spreadValues({}, SIMULATION_HEADER_CONTAINER), { children: [
        /* @__PURE__ */ jsx10(Text8, __spreadProps(__spreadValues({}, SIMULATION_HEADER_TEXT), { children: "Simulasi Foto" })),
        /* @__PURE__ */ jsx10(Button6, __spreadProps(__spreadValues({}, SIMULATION_BUTTON_SECONDARY), { onClick: onOpen, children: "Reset Foto" }))
      ] })),
      /* @__PURE__ */ jsxs8(Box8, __spreadProps(__spreadValues({}, SIMULATION_BODY_CONTAINER), { children: [
        /* @__PURE__ */ jsx10(Text8, __spreadProps(__spreadValues({}, SIMULATION_SUBTITLE_TEXT), { p: "16px 0 8px", children: "Unggah foto pre-wedding Anda sesuai kebutuhan di bawah untuk mendapatkan experience yang sempurna!" })),
        /* @__PURE__ */ jsxs8(Box8, { display: "flex", justifyContent: "space-around", w: "100%", children: [
          imageHelperLink && /* @__PURE__ */ jsx10(Link, { href: imageHelperLink, target: "_blank", children: /* @__PURE__ */ jsx10(Button6, __spreadProps(__spreadValues({}, SIMULATION_BUTTON_ALTERNATIVE), { p: "0 12px", children: "Panduan Foto" })) }),
          assetsHelperLink && /* @__PURE__ */ jsx10(Link, { href: assetsHelperLink, target: "_blank", children: /* @__PURE__ */ jsx10(Button6, __spreadProps(__spreadValues({}, SIMULATION_BUTTON_ALTERNATIVE), { p: "0 12px", children: "Panduan Asset" })) })
        ] }),
        imageForm.map(({ imageConstant, imageName, imageValue }) => /* @__PURE__ */ jsx10(
          ImageDrop_default,
          {
            imageName,
            imageConstant,
            imageObject: imageValue,
            onChange: (imageConstant2, newValue) => onSetImage(imageConstant2, newValue)
          },
          imageConstant
        ))
      ] }))
    ] })),
    /* @__PURE__ */ jsx10(
      ConfirmationAlert_default,
      {
        isOpenAlert: isOpen,
        onCloseAlert: onClose,
        onConfirm: onHandleReset,
        title: "Reset Foto",
        desc: "Apakah Anda yakin? Anda tidak dapat membatalkan tindakan ini setelahnya."
      }
    )
  ] });
};
var SimulationImage_default = SimulationImage;

// src/components/SimulationConfig/SimulationConfig.tsx
import { useState as useState10 } from "react";
import {
  Box as Box9,
  Button as Button7,
  Center as Center2,
  Divider as Divider4,
  Spinner,
  Text as Text9,
  useDisclosure as useDisclosure4,
  useToast as useToast6
} from "@chakra-ui/react";
import { LuDownload, LuFileInput } from "react-icons/lu";
import { BsFiletypeJson } from "react-icons/bs";
import { Fragment as Fragment6, jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var SimulationConfig = () => {
  const [unchangedCount, setUnchangedCount] = useState10([]);
  const [isLoading, setIsLoading] = useState10(false);
  const {
    currentFile,
    colorForm,
    imageForm,
    fontForm,
    coupleForm,
    onSetCurrentFile,
    onHandleLoadColor,
    onHandleLoadFont,
    onHandleLoadCouple,
    onHandleLoadImage
  } = useImaginationRoom();
  const { isOpen, onOpen, onClose } = useDisclosure4();
  const {
    isOpen: isOpenConfirmation,
    onOpen: onOpenConfirmation,
    onClose: onCloseConfirmation
  } = useDisclosure4();
  const toast = useToast6();
  const handleDownload = () => {
    setIsLoading(true);
    try {
      const payload = { colorForm, fontForm, coupleForm, imageForm };
      const finalPayload = JSON.stringify(payload);
      const blob = new Blob([finalPayload], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `invitato - ${coupleForm.coupleName}.json`;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx11(
          CustomToast_default,
          {
            status: "success",
            title: "Sukses!",
            desc: "Berhasil menyimpan simulasi.",
            id,
            onClose: onClose2
          }
        )
      });
    } catch (e) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx11(
          CustomToast_default,
          {
            status: "error",
            title: "Oops!",
            desc: "Terjadi kesalahan. Mohon muat ulang browser Anda atau coba lagi nanti.",
            id,
            onClose: onClose2
          }
        )
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleImport = (eventOrFile) => {
    let file;
    if ("target" in eventOrFile && eventOrFile.target.files) {
      file = eventOrFile.target.files[0];
    } else {
      file = eventOrFile;
    }
    if (!file) {
      console.error("No file selected.");
      return;
    }
    onSetCurrentFile(file.name);
    const reader = new FileReader();
    reader.onload = (e) => {
      if (!e.target || typeof e.target.result !== "string") {
        console.error("Error reading file.");
        return;
      }
      try {
        const formData = JSON.parse(e.target.result);
        if (formData.colorForm) {
          onHandleLoadColor(formData.colorForm);
        }
        if (formData.fontForm) {
          onHandleLoadFont(formData.fontForm);
        }
        if (formData.coupleForm) {
          onHandleLoadCouple(formData.coupleForm);
        }
        if (formData.imageForm) {
          onHandleLoadImage(formData.imageForm);
        }
        toast({
          position: "top",
          duration: 5e3,
          render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx11(
            CustomToast_default,
            {
              status: "success",
              title: "Import berhasil!",
              desc: "Data dari file .json berhasil diimpor.",
              id,
              onClose: onClose2
            }
          )
        });
      } catch (error) {
        console.error("Error parsing JSON:", error);
        toast({
          position: "top",
          duration: 5e3,
          render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx11(
            CustomToast_default,
            {
              status: "error",
              title: "Oops!",
              desc: "Terjadi kesalahan saat mengimpor data.",
              id,
              onClose: onClose2
            }
          )
        });
      }
    };
    reader.readAsText(file);
  };
  const handleExport = () => {
    const unchangedImages = [];
    imageForm.map(({ imageName, imageValue }) => {
      if (imageValue.includes("https")) {
        unchangedImages.push(imageName);
      }
    });
    if (unchangedImages.length !== 0) {
      setUnchangedCount(unchangedImages);
      onOpen();
    } else {
      onOpenConfirmation();
    }
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      handleImport(file);
    }
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleConfirmAlert = () => {
    onClose();
    onOpenConfirmation();
  };
  const handleConfirm = () => {
    onCloseConfirmation();
    handleDownload();
  };
  return /* @__PURE__ */ jsxs9(Fragment6, { children: [
    /* @__PURE__ */ jsxs9(Box9, __spreadProps(__spreadValues({}, SIMULATION_CONTAINER_PROPS), { children: [
      /* @__PURE__ */ jsx11(Box9, __spreadProps(__spreadValues({}, SIMULATION_HEADER_CONTAINER), { children: /* @__PURE__ */ jsx11(Text9, __spreadProps(__spreadValues({}, SIMULATION_HEADER_TEXT), { children: "Konfigurasi Simulasi" })) })),
      /* @__PURE__ */ jsxs9(Box9, __spreadProps(__spreadValues({}, SIMULATION_BODY_CONTAINER), { fontFamily: "poppins", children: [
        /* @__PURE__ */ jsx11(Text9, __spreadProps(__spreadValues({}, SIMULATION_SUBTITLE_TEXT), { p: "16px 0 ", children: "Simpan konfigurasi yang sudah Anda buat dan kirimkan kepada tim admin kami." })),
        /* @__PURE__ */ jsxs9(
          Button7,
          __spreadProps(__spreadValues({}, SIMULATION_BUTTON_PRIMARY), {
            p: "0 12px 0 18px",
            w: "100%",
            h: "48px",
            fontSize: "1rem",
            m: "0 auto ",
            onClick: handleExport,
            isLoading,
            children: [
              "Simpan Simulasi",
              /* @__PURE__ */ jsx11(Box9, { ml: "10px", children: /* @__PURE__ */ jsx11(LuDownload, { size: 24, color: "#FFF" }) })
            ]
          })
        ),
        /* @__PURE__ */ jsx11(Divider4, { my: "16px" }),
        /* @__PURE__ */ jsx11(Text9, __spreadProps(__spreadValues({}, SIMULATION_SUBTITLE_TEXT), { children: "Unggah hasil simulasi yang sudah pernah Anda buat untuk bisa melihatnya kembali." })),
        /* @__PURE__ */ jsxs9(
          Box9,
          {
            mt: "1rem",
            border: "1px dashed #55555526",
            color: "black",
            p: "32px 16px",
            width: "100%",
            bgColor: "rgba(245,245,245, 0.2)",
            onClick: () => {
              var _a;
              return (_a = document.getElementById("fileImport")) == null ? void 0 : _a.click();
            },
            onDrop: handleDrop,
            onDragOver: handleDragOver,
            style: { cursor: "pointer" },
            pos: "relative",
            borderRadius: "8px",
            children: [
              /* @__PURE__ */ jsx11(
                "input",
                {
                  type: "file",
                  id: "fileImport",
                  accept: ".json",
                  style: { display: "none" },
                  onChange: (e) => handleImport(e)
                }
              ),
              isLoading ? /* @__PURE__ */ jsx11(Center2, { h: "100%", children: /* @__PURE__ */ jsx11(Spinner, { color: "#a1425c", size: "lg" }) }) : /* @__PURE__ */ jsx11(Box9, { children: /* @__PURE__ */ jsxs9(Center2, { h: "100%", justifyContent: "space-around", children: [
                /* @__PURE__ */ jsx11(LuFileInput, { size: 32, color: "#000" }),
                /* @__PURE__ */ jsx11(Box9, { children: currentFile ? /* @__PURE__ */ jsxs9(Fragment6, { children: [
                  /* @__PURE__ */ jsx11(Text9, { fontWeight: "500", fontSize: "0.75rem", children: "Saat ini sedang menggunakan" }),
                  /* @__PURE__ */ jsx11(Text9, { fontSize: "0.75rem", color: "green.500", children: currentFile })
                ] }) : /* @__PURE__ */ jsxs9(Fragment6, { children: [
                  /* @__PURE__ */ jsx11(Text9, { fontWeight: "500", fontSize: "0.75rem", children: "Drag & drop data simulasi disini" }),
                  /* @__PURE__ */ jsx11(Text9, { color: "grey", fontSize: "0.75rem", children: "File harus dalam format (.json)" })
                ] }) })
              ] }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx11(Box9, { display: "flex", w: "100%", children: /* @__PURE__ */ jsxs9(
          Button7,
          __spreadProps(__spreadValues({}, SIMULATION_BUTTON_SECONDARY), {
            p: "0 12px 0 18px",
            fontSize: "0.75rem",
            m: "6px auto 0 auto",
            onClick: () => {
              var _a;
              return (_a = document.getElementById("fileImport")) == null ? void 0 : _a.click();
            },
            children: [
              "Import Konfigurasi Simulasi",
              /* @__PURE__ */ jsx11(Box9, { ml: "10px", children: /* @__PURE__ */ jsx11(LuFileInput, { size: 14, color: "#ba5c76" }) })
            ]
          })
        ) })
      ] }))
    ] })),
    /* @__PURE__ */ jsx11(
      ConfirmationAlert_default,
      {
        isOpenAlert: isOpen,
        onCloseAlert: onClose,
        onConfirm: () => handleConfirmAlert(),
        title: "Simpan Simulasi",
        children: /* @__PURE__ */ jsxs9(
          Box9,
          __spreadProps(__spreadValues({}, SIMULATION_SUBTITLE_TEXT), {
            fontSize: "0.875rem",
            fontStyle: "normal",
            textAlign: "left",
            children: [
              /* @__PURE__ */ jsxs9(Text9, { children: [
                "Ada ",
                unchangedCount.length,
                " Foto yang belum diubah:"
              ] }),
              unchangedCount.map((data, index) => /* @__PURE__ */ jsx11(Text9, { children: `${index + 1}. ${data}` }, data)),
              /* @__PURE__ */ jsx11(Text9, { mt: 2, children: "Apakah Anda yakin tetap ingin menyimpan?" })
            ]
          })
        )
      }
    ),
    /* @__PURE__ */ jsx11(
      ConfirmationAlert_default,
      {
        isOpenAlert: isOpenConfirmation,
        onCloseAlert: onCloseConfirmation,
        onConfirm: handleConfirm,
        title: "Simpan Simulasi",
        buttonIcon: /* @__PURE__ */ jsx11(BsFiletypeJson, { color: "#FFF", size: 16 }),
        buttonText: "Simpan File .json",
        desc: "File yang akan disimpan adalah format <b>file .json</b> yang dapat diberikan kepada admin. File juga dapat di unggah kembali untuk melanjutkan simulasi sebelumnya dengan drag and drop file atau klik tombol \u201CImport Konfigurasi Simulasi\u201D."
      }
    )
  ] });
};
var SimulationConfig_default = SimulationConfig;

// src/components/SimulationFont/SimulationFont.tsx
import { useState as useState15 } from "react";
import {
  Box as Box17,
  Button as Button14,
  Center as Center7,
  CircularProgress as CircularProgress2,
  Text as Text17,
  useDisclosure as useDisclosure8,
  useToast as useToast7
} from "@chakra-ui/react";
import { scroller as scroller2 } from "react-scroll";

// src/components/SimulationFont/FontEditor/FontEditor.tsx
import { useState as useState12 } from "react";
import { Box as Box13, Button as Button12, Divider as Divider5, Flex as Flex2, Text as Text13 } from "@chakra-ui/react";

// src/components/SimulationFont/FontEditor/FontSelectionMenu/FontSelectionMenu.tsx
import { useMemo as useMemo4, useState as useState11, useCallback as useCallback2 } from "react";
import {
  Box as Box10,
  Button as Button8,
  Center as Center3,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Popover as Popover2,
  PopoverContent as PopoverContent2,
  PopoverTrigger as PopoverTrigger2,
  Skeleton,
  Text as Text10,
  useDisclosure as useDisclosure5
} from "@chakra-ui/react";
import { LuCheck, LuChevronDown, LuSearch, LuX as LuX2 } from "react-icons/lu";

// src/usecase/use-intersect/useIntersect.ts
import { useRef as useRef2, useEffect as useEffect3, useCallback } from "react";

// src/model/use-intersect/constants.ts
var DEFAULT_OPTIONS_DATA = {
  root: null,
  rootMargin: "0px",
  threshold: [0.05, 0.3, 0.6, 0.95]
};

// src/usecase/use-intersect/useIntersect.ts
var useIntersect = ({
  onIntersect,
  optionsData,
  onlyOnce = true
}) => {
  const intersected = useRef2(false);
  const targetRef = useRef2(null);
  const observer = useRef2(null);
  const options = optionsData || DEFAULT_OPTIONS_DATA;
  const handleIntersect = useCallback(
    (entries) => {
      const isIntersecting = entries[0] && entries[0].isIntersecting || false;
      if (isIntersecting) {
        onIntersect();
        if (!intersected.current && observer.current && onlyOnce) {
          observer.current.disconnect();
          observer.current = null;
          intersected.current = true;
        }
      }
    },
    [onIntersect, onlyOnce]
  );
  useEffect3(() => {
    if (!intersected.current && !observer.current) {
      const Intersection = new IntersectionObserver(handleIntersect, options);
      if (Intersection && targetRef.current) {
        observer.current = Intersection;
        observer.current.observe(targetRef.current);
      }
    }
    return () => {
      if (observer.current) {
        observer.current.disconnect();
        observer.current = null;
      }
    };
  }, [handleIntersect, options, targetRef]);
  return targetRef;
};
var useIntersect_default = useIntersect;

// src/components/SimulationFont/styles.ts
var SELECTION_BUTTON_STYLE = {
  display: "flex",
  justifyContent: "flex-start",
  bg: "transparent",
  alignItems: "center",
  w: "100%",
  p: "8px 12px",
  fontWeight: "400",
  _hover: { bgColor: "rgba(183, 82, 109, 0.12)" }
};

// src/components/SimulationFont/FontEditor/FontSelectionMenu/FontSelectionMenu.tsx
import { Fragment as Fragment7, jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
import { createElement } from "react";
var FontSelectionMenu = ({
  selectedFontFamily,
  fontCSS,
  fontCategory,
  onChange
}) => {
  const [searchText, setSearchText] = useState11("");
  const [isInvalid, setIsInvalid] = useState11(false);
  const [isNotFound, setIsNotFound] = useState11(false);
  const [loadedFonts, setLoadedFonts] = useState11(10);
  const { isOpen, onClose, onToggle } = useDisclosure5();
  const { fontList, fontRecommendation } = useImaginationRoom();
  const getFontOptions = (fontCategory2) => {
    switch (fontCategory2) {
      case "body":
        return fontRecommendation.body_font || [];
      case "heading":
        return fontRecommendation.heading_font || [];
      case "subheading":
        return fontRecommendation.sub_heading_font || [];
      default:
        return [];
    }
  };
  const finalRecommendedFonts = getFontOptions(fontCategory);
  const debounceText = useDebounce_default(searchText, 500);
  const finalFonts = useMemo4(() => {
    setIsNotFound(false);
    if (searchText.length < 3) return [];
    const searchKey = debounceText.toLowerCase();
    const tempFonts = fontList.filter((item) => item.family.toLowerCase().includes(searchKey));
    if (tempFonts.length === 0) {
      setIsNotFound(true);
    }
    return tempFonts;
  }, [debounceText]);
  const maxLoadedFonts = fontList.length;
  const loadMoreFonts = useCallback2(() => {
    if (maxLoadedFonts > loadedFonts) {
      setLoadedFonts((prev) => prev + 10);
    }
  }, []);
  const lastFontRef = useIntersect_default({
    onIntersect: loadMoreFonts,
    onlyOnce: false
  });
  const handleClickFontFamily = (event) => {
    const value = event.currentTarget.value;
    onChange(value);
    onClose();
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    setIsInvalid(value.length < 3 && value.length > 0);
    setSearchText(e.target.value);
  };
  return /* @__PURE__ */ jsx12(Fragment7, { children: /* @__PURE__ */ jsxs10(Popover2, { isOpen, onClose: onToggle, children: [
    /* @__PURE__ */ jsx12(PopoverTrigger2, { children: /* @__PURE__ */ jsxs10(
      Button8,
      {
        bg: "transparent",
        px: "8px",
        alignItems: "center",
        justifyItems: "center",
        borderRadius: "md",
        border: "1px solid #55555526",
        fontFamily: selectedFontFamily,
        _hover: { bgColor: "rgba(183, 82, 109, 0.12)" },
        onClick: onToggle,
        w: "100%",
        justifyContent: "flex-start",
        children: [
          /* @__PURE__ */ jsx12(Text10, { textAlign: "left", fontWeight: "400", children: selectedFontFamily }),
          /* @__PURE__ */ jsx12(Center3, { mr: "0", ml: "auto", children: /* @__PURE__ */ jsx12(LuChevronDown, {}) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs10(PopoverContent2, { w: "274px", maxH: "300px", overflow: "auto", zIndex: "4", children: [
      /* @__PURE__ */ jsxs10(Box10, { p: "4px 8px", children: [
        /* @__PURE__ */ jsxs10(InputGroup, { children: [
          /* @__PURE__ */ jsx12(InputLeftElement, { pointerEvents: "none", children: /* @__PURE__ */ jsx12(LuSearch, {}) }),
          /* @__PURE__ */ jsx12(
            Input,
            {
              value: searchText,
              onChange: handleSearch,
              isInvalid,
              fontSize: "14px",
              placeholder: "Cari font..."
            }
          ),
          searchText && /* @__PURE__ */ jsx12(
            InputRightElement,
            {
              onClick: () => setSearchText(""),
              cursor: "pointer",
              _hover: { bgColor: "rgba(183, 82, 109, 0.12)" },
              children: /* @__PURE__ */ jsx12(LuX2, {})
            }
          )
        ] }),
        isInvalid && /* @__PURE__ */ jsx12(Text10, { color: "red.500", fontSize: "xs", mt: "4px", children: "*Minimal 3 karakter." })
      ] }),
      /* @__PURE__ */ jsxs10(Box10, { overflowY: "auto", children: [
        finalFonts.length === 0 && searchText.length < 3 && /* @__PURE__ */ createElement(
          Button8,
          __spreadProps(__spreadValues({}, SELECTION_BUTTON_STYLE), {
            p: "12px 16px",
            key: selectedFontFamily + "selected" + fontCSS,
            value: selectedFontFamily,
            fontFamily: selectedFontFamily,
            onClick: handleClickFontFamily,
            overflow: "hidden"
          }),
          /* @__PURE__ */ jsx12(Box10, { display: "inline-flex", mr: "8px", children: /* @__PURE__ */ jsx12(LuCheck, {}) }),
          /* @__PURE__ */ jsx12(Text10, { fontWeight: "400", textAlign: "left", fontSize: "1rem", textOverflow: "ellipsis", children: selectedFontFamily })
        ),
        searchText.length >= 3 && finalFonts.length > 0 ? /* @__PURE__ */ jsx12(Fragment7, { children: finalFonts.map((font, index) => {
          loadGoogleFont_default(font.family);
          return /* @__PURE__ */ createElement(
            Button8,
            __spreadProps(__spreadValues({}, SELECTION_BUTTON_STYLE), {
              p: "12px 16px",
              key: font.family + "search" + index + fontCSS,
              value: font.family,
              fontFamily: font.family,
              onClick: handleClickFontFamily,
              overflow: "hidden",
              pl: "41px"
            }),
            /* @__PURE__ */ jsx12(
              Text10,
              {
                fontWeight: "400",
                textAlign: "left",
                fontSize: "1rem",
                textOverflow: "ellipsis",
                children: font.family
              }
            )
          );
        }) }) : searchText.length >= 3 && /* @__PURE__ */ jsx12(Box10, { pl: "41px", py: "10px", pr: "36px", children: isNotFound ? /* @__PURE__ */ jsx12(Text10, { fontFamily: "poppins", fontWeight: "400", textAlign: "left", fontSize: "0.75rem", children: "Font tidak ditemukan..." }) : /* @__PURE__ */ jsx12(Skeleton, { w: "100%", h: "20px" }) }),
        searchText.length < 3 && /* @__PURE__ */ jsxs10(Fragment7, { children: [
          finalRecommendedFonts.map((font, index) => {
            if (font !== selectedFontFamily) {
              loadGoogleFont_default(font);
              return /* @__PURE__ */ createElement(
                Button8,
                __spreadProps(__spreadValues({}, SELECTION_BUTTON_STYLE), {
                  p: "12px 16px",
                  key: font + "recommended" + index + fontCSS,
                  value: font,
                  fontFamily: font,
                  onClick: handleClickFontFamily,
                  overflow: "hidden",
                  pl: "41px"
                }),
                /* @__PURE__ */ jsx12(
                  Text10,
                  {
                    fontWeight: "400",
                    textAlign: "left",
                    fontSize: "1rem",
                    textOverflow: "ellipsis",
                    children: font
                  }
                )
              );
            }
            return null;
          }),
          fontList.filter((_, index) => index < loadedFonts).map((font, index) => {
            loadGoogleFont_default(font.family);
            return /* @__PURE__ */ createElement(
              Button8,
              __spreadProps(__spreadValues({}, SELECTION_BUTTON_STYLE), {
                p: "12px 16px",
                key: font.family + "lazy" + index + fontCSS,
                value: font.family,
                fontFamily: font.family,
                onClick: handleClickFontFamily,
                overflow: "hidden",
                pl: "41px"
              }),
              /* @__PURE__ */ jsx12(
                Text10,
                {
                  fontWeight: "400",
                  textAlign: "left",
                  fontSize: "1rem",
                  textOverflow: "ellipsis",
                  children: font.family
                }
              )
            );
          }),
          /* @__PURE__ */ jsx12("div", { "data-testid": "intersection", ref: lastFontRef, children: /* @__PURE__ */ jsx12(Box10, { pl: "41px", py: "10px", pr: "36px", children: maxLoadedFonts > loadedFonts ? /* @__PURE__ */ jsx12(Skeleton, { w: "100%", h: "20px" }) : /* @__PURE__ */ jsx12(
            Text10,
            {
              fontFamily: "poppins",
              fontWeight: "400",
              textAlign: "left",
              fontSize: "0.75rem",
              children: "Semua font sudah ditampilkan..."
            }
          ) }) })
        ] })
      ] })
    ] })
  ] }) });
};
var FontSelectionMenu_default = FontSelectionMenu;

// src/components/SimulationFont/FontEditor/BoldSelectionMenu/BoldSelectionMenu.tsx
import { useMemo as useMemo5 } from "react";
import {
  HStack,
  Text as Text11,
  Button as Button9,
  Box as Box11,
  Center as Center4,
  useDisclosure as useDisclosure6,
  Popover as Popover3,
  PopoverTrigger as PopoverTrigger3,
  PopoverContent as PopoverContent3
} from "@chakra-ui/react";
import { LuBold, LuCheck as LuCheck2 } from "react-icons/lu";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
import { createElement as createElement2 } from "react";
var getFontWeight = (fontWeight) => {
  switch (fontWeight) {
    case "100":
      return "Thin";
    case "200":
      return "Extra Light";
    case "300":
      return "Light";
    case "400":
      return "Regular";
    case "500":
      return "Medium";
    case "600":
      return "Semi Bold";
    case "700":
      return "Bold";
    case "800":
      return "Extra Bold";
    case "900":
      return "Black";
    default:
      return fontWeight;
  }
};
var BoldSelectionMenu = ({
  selectedFontFamily,
  selectedFontWeight,
  fontCSS,
  onChange
}) => {
  const { isOpen, onToggle } = useDisclosure6();
  const { fontList } = useImaginationRoom();
  const finalFontWeightList = useMemo5(() => {
    return fontList.find((font) => font.family === selectedFontFamily);
  }, [selectedFontFamily]);
  const filteredVariants = finalFontWeightList ? finalFontWeightList.variants.filter(
    (variant) => !variant.includes("italic")
  ) : [];
  const handleClickFontWeight = (event) => {
    const value = event.currentTarget.value;
    onChange(value);
  };
  const isBold = selectedFontWeight === "400" || selectedFontWeight === "regular";
  return /* @__PURE__ */ jsx13(HStack, { children: /* @__PURE__ */ jsxs11(Popover3, { isOpen, onClose: onToggle, children: [
    /* @__PURE__ */ jsx13(PopoverTrigger3, { children: /* @__PURE__ */ jsx13(
      Button9,
      {
        bg: !isBold ? "rgba(183, 82, 109, 0.24)" : "transparent",
        px: "8px",
        alignItems: "center",
        justifyItems: "center",
        borderRadius: "md",
        border: "1px solid #55555526",
        _hover: !isBold ? {} : { bgColor: "rgba(183, 82, 109, 0.12)" },
        onClick: onToggle,
        children: /* @__PURE__ */ jsx13(Center4, { children: /* @__PURE__ */ jsx13(LuBold, { color: !isBold ? "#ba5c76" : "black" }) })
      }
    ) }),
    /* @__PURE__ */ jsx13(PopoverContent3, { w: "104px", maxH: "200px", overflow: "auto", zIndex: "4", children: filteredVariants && filteredVariants.map((data) => /* @__PURE__ */ createElement2(
      Button9,
      __spreadProps(__spreadValues({}, SELECTION_BUTTON_STYLE), {
        key: data + fontCSS,
        value: data,
        onClick: handleClickFontWeight,
        p: "10px 8px",
        _hover: { bgColor: "rgba(183, 82, 109, 0.12)" }
      }),
      /* @__PURE__ */ jsx13(
        Text11,
        {
          fontWeight: data,
          fontFamily: selectedFontFamily,
          textTransform: "capitalize",
          textAlign: "left",
          ml: "0",
          mr: "auto",
          children: getFontWeight(data)
        }
      ),
      data === selectedFontWeight && /* @__PURE__ */ jsx13(Box11, { display: "inline-flex", ml: "auto", mr: "0", children: /* @__PURE__ */ jsx13(LuCheck2, {}) })
    )) })
  ] }) });
};
var BoldSelectionMenu_default = BoldSelectionMenu;

// src/components/SimulationFont/FontEditor/FontSizeMenu/FontSizeMenu.tsx
import {
  Input as Input2,
  Button as Button10,
  HStack as HStack2,
  Box as Box12,
  Center as Center5,
  useDisclosure as useDisclosure7,
  Popover as Popover4,
  PopoverTrigger as PopoverTrigger4,
  PopoverContent as PopoverContent4,
  Text as Text12
} from "@chakra-ui/react";
import { LuCheck as LuCheck3, LuChevronDown as LuChevronDown2 } from "react-icons/lu";
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var FontSizeMenu = ({
  selectedFontSize,
  fontCSS,
  onChange
}) => {
  const { isOpen, onToggle } = useDisclosure7();
  const handleInputFontSize = (e) => {
    e.preventDefault();
    const value = e.target.value;
    onChange(value);
  };
  const handleClickFontSize = (event) => {
    const value = event.currentTarget.value;
    onChange(value);
  };
  return /* @__PURE__ */ jsxs12(HStack2, { pos: "relative", children: [
    /* @__PURE__ */ jsx14(
      Input2,
      {
        placeholder: "- -",
        value: selectedFontSize,
        onChange: handleInputFontSize,
        width: "51px",
        mr: "0",
        px: "8px",
        fontSize: "14px",
        _active: { border: "1px 0 1px 1px solid #55555526" },
        _focus: { border: "1px 0 1px 1px solid #55555526" },
        _focusVisible: { border: "1px 0 1px 1px solid #55555526" },
        borderRightRadius: "none",
        borderRight: "none"
      }
    ),
    /* @__PURE__ */ jsxs12(Popover4, { isOpen, onClose: onToggle, children: [
      /* @__PURE__ */ jsx14(PopoverTrigger4, { children: /* @__PURE__ */ jsx14(
        Button10,
        {
          bg: "transparent",
          px: "8px",
          alignItems: "center",
          justifyItems: "center",
          borderRadius: "md",
          border: "1px solid #55555526",
          borderLeft: "none",
          borderLeftRadius: "none",
          ml: "-9px",
          _hover: { bgColor: "rgba(183, 82, 109, 0.12)" },
          onClick: onToggle,
          children: /* @__PURE__ */ jsx14(Center5, { children: /* @__PURE__ */ jsx14(LuChevronDown2, {}) })
        }
      ) }),
      /* @__PURE__ */ jsx14(PopoverContent4, { w: "96px", maxH: "200px", overflow: "auto", zIndex: "4", children: FONT_SIZES.map((data) => /* @__PURE__ */ jsxs12(
        Button10,
        __spreadProps(__spreadValues({
          value: data,
          onClick: handleClickFontSize
        }, SELECTION_BUTTON_STYLE), {
          children: [
            /* @__PURE__ */ jsx14(
              Text12,
              {
                fontFamily: "poppins",
                fontWeight: "300",
                textAlign: "left",
                ml: "0",
                mr: "auto",
                fontSize: "14px",
                children: data
              }
            ),
            data === selectedFontSize && /* @__PURE__ */ jsx14(Box12, { display: "inline-flex", ml: "auto", mr: "0", children: /* @__PURE__ */ jsx14(LuCheck3, {}) })
          ]
        }),
        data + fontCSS
      )) })
    ] })
  ] });
};
var FontSizeMenu_default = FontSizeMenu;

// src/components/SimulationFont/FontEditor/ItalicMenu/ItalicMenu.tsx
import { Button as Button11, Center as Center6 } from "@chakra-ui/react";
import { LuItalic } from "react-icons/lu";
import { jsx as jsx15 } from "react/jsx-runtime";
var ItalicMenu = ({ isItalic, onChange }) => {
  return /* @__PURE__ */ jsx15(
    Button11,
    {
      bg: isItalic ? "rgba(183, 82, 109, 0.24)" : "transparent",
      px: "8px",
      alignItems: "center",
      justifyItems: "center",
      borderRadius: "md",
      border: "1px solid #55555526",
      _hover: isItalic ? {} : { bgColor: "rgba(183, 82, 109, 0.12)" },
      onClick: () => onChange(!isItalic),
      children: /* @__PURE__ */ jsx15(Center6, { children: /* @__PURE__ */ jsx15(LuItalic, { color: isItalic ? "#ba5c76" : "black" }) })
    }
  );
};
var ItalicMenu_default = ItalicMenu;

// src/components/SimulationFont/FontEditor/FontEditor.tsx
import { Fragment as Fragment8, jsx as jsx16, jsxs as jsxs13 } from "react/jsx-runtime";
var FontEditor = ({ fontData, onChange, onScrollTo }) => {
  const {
    fontCSS,
    fontCategory,
    fontFamilyValue,
    fontName,
    fontSizeValue,
    fontWeightValue,
    isFontItalic
  } = fontData;
  const [selectedFontFamily, setSelectedFontFamily] = useState12(fontFamilyValue);
  const [selectedFontSize, setSelectedFontSize] = useState12(fontSizeValue);
  const [selectedFontWeight, setSelectedFontWeight] = useState12(fontWeightValue);
  const [isItalic, setIsItalic] = useState12(isFontItalic);
  const handleSelectedFontFamily = (value) => {
    setSelectedFontFamily(value);
    setSelectedFontWeight("regular");
    setIsItalic(false);
    handleFontChange(__spreadProps(__spreadValues({}, fontData), {
      fontFamilyValue: value,
      fontWeightValue: "regular",
      isFontItalic: false
    }));
  };
  const handleFontSize = (value) => {
    setSelectedFontSize(value);
    handleFontChange(__spreadProps(__spreadValues({}, fontData), { fontSizeValue: value }));
  };
  const handleFontWeight = (value) => {
    setSelectedFontWeight(value);
    handleFontChange(__spreadProps(__spreadValues({}, fontData), { fontWeightValue: value }));
  };
  const handleSetItalic = (value) => {
    setIsItalic(value);
    handleFontChange(__spreadProps(__spreadValues({}, fontData), { isFontItalic: value }));
  };
  const handleFontChange = (fontData2) => {
    onChange(fontData2);
  };
  return /* @__PURE__ */ jsxs13(Fragment8, { children: [
    /* @__PURE__ */ jsx16(Box13, { py: "16px", w: "100%", pos: "relative", children: /* @__PURE__ */ jsxs13(Flex2, { w: "100%", justifyContent: "space-between", flexDir: "column", children: [
      /* @__PURE__ */ jsxs13(Flex2, { justify: "space-between", align: "baseline", mb: "8px", children: [
        /* @__PURE__ */ jsx16(
          Text13,
          {
            pl: "4px",
            mb: "8px",
            color: "black",
            fontFamily: `"Poppins", serif;`,
            fontWeight: "500",
            fontSize: "14px",
            children: fontName
          }
        ),
        /* @__PURE__ */ jsx16(Button12, __spreadProps(__spreadValues({}, SIMULATION_BUTTON_ALTERNATIVE), { onClick: onScrollTo, children: "Lihat" }))
      ] }),
      /* @__PURE__ */ jsx16(
        FontSelectionMenu_default,
        {
          selectedFontFamily,
          fontCSS,
          fontCategory,
          onChange: handleSelectedFontFamily
        }
      ),
      /* @__PURE__ */ jsxs13(Flex2, { w: "100%", mt: "8px", justifyContent: "flex-start", gap: "8px", children: [
        /* @__PURE__ */ jsx16(
          FontSizeMenu_default,
          {
            fontCSS,
            selectedFontSize,
            onChange: handleFontSize
          }
        ),
        /* @__PURE__ */ jsx16(
          BoldSelectionMenu_default,
          {
            fontCSS,
            selectedFontFamily,
            selectedFontWeight,
            onChange: handleFontWeight
          }
        ),
        /* @__PURE__ */ jsx16(ItalicMenu_default, { isItalic, onChange: handleSetItalic })
      ] })
    ] }) }),
    /* @__PURE__ */ jsx16(Divider5, { borderColor: "#55555526" })
  ] });
};
var FontEditor_default = FontEditor;

// src/components/SimulationFont/CoupleConfig/CoupleConfig.tsx
import { useEffect as useEffect4, useState as useState14 } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box as Box16,
  Text as Text16
} from "@chakra-ui/react";

// src/model/couple/constants.ts
var COUPLE_LS_KEY = "adm-vrf";
var COUPLE_ADMIN_PASSWORD = "INV-0001";

// src/components/SimulationFont/CoupleConfig/CoupleAuth/CoupleAuth.tsx
import { useState as useState13 } from "react";
import {
  Box as Box14,
  Button as Button13,
  Input as Input3,
  InputGroup as InputGroup2,
  InputLeftElement as InputLeftElement2,
  InputRightElement as InputRightElement2,
  Text as Text14
} from "@chakra-ui/react";
import { LuEye, LuEyeOff, LuKeyRound } from "react-icons/lu";
import { jsx as jsx17, jsxs as jsxs14 } from "react/jsx-runtime";
var CoupleAuth = ({
  adminPassword,
  onSetAdminPassword,
  onValidateAdminPassword
}) => {
  const [show, setShow] = useState13(false);
  const [isInvalid, setIsInvalid] = useState13(false);
  const handleValidate = () => {
    const validator = onValidateAdminPassword();
    if (!validator) {
      setIsInvalid(true);
    }
  };
  return /* @__PURE__ */ jsxs14(Box14, { display: "flex", flexDir: "column", children: [
    /* @__PURE__ */ jsxs14(InputGroup2, { children: [
      /* @__PURE__ */ jsx17(InputLeftElement2, { pointerEvents: "none", children: /* @__PURE__ */ jsx17(LuKeyRound, {}) }),
      /* @__PURE__ */ jsx17(
        Input3,
        {
          value: adminPassword,
          fontSize: "14px",
          placeholder: "Masukkan password",
          type: show ? "text" : "password",
          onChange: (e) => onSetAdminPassword(e.target.value),
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              handleValidate();
            }
          }
        }
      ),
      /* @__PURE__ */ jsx17(InputRightElement2, { children: /* @__PURE__ */ jsx17(
        Box14,
        {
          onClick: () => setShow(!show),
          cursor: "pointer",
          _hover: { bgColor: "rgba(183, 82, 109, 0.12)" },
          p: "8px",
          borderRadius: "5px",
          children: show ? /* @__PURE__ */ jsx17(LuEye, { color: "rgb(186, 92, 118)" }) : /* @__PURE__ */ jsx17(LuEyeOff, { color: "rgb(186, 92, 118)" })
        }
      ) })
    ] }),
    isInvalid && /* @__PURE__ */ jsx17(Text14, { color: "red.500", fontSize: "xs", mt: "4px", children: "Password tidak sesuai." }),
    /* @__PURE__ */ jsx17(
      Button13,
      __spreadProps(__spreadValues({}, SIMULATION_BUTTON_ALTERNATIVE), {
        onClick: handleValidate,
        mt: "6px",
        alignSelf: "end",
        borderRadius: "5px",
        children: "Submit"
      })
    )
  ] });
};
var CoupleAuth_default = CoupleAuth;

// src/utils/local/set.ts
import canUseDOM7 from "@invitato/helpers/dist/canUseDOM";
function setLocalItem(KEY, value) {
  try {
    if (canUseDOM7) {
      localStorage.setItem(KEY, value);
      return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}

// src/utils/local/get.ts
import { canUseDOM as canUseDOM8 } from "@invitato/helpers";
function getLocalItem(KEY) {
  try {
    if (canUseDOM8) {
      const result = localStorage.getItem(KEY);
      return result;
    }
    return void 0;
  } catch (e) {
    return void 0;
  }
}

// src/components/SimulationFont/CoupleConfig/CoupleMenu/CoupleMenu.tsx
import { Box as Box15, Input as Input4, Text as Text15 } from "@chakra-ui/react";

// src/components/SimulationFont/CoupleConfig/CoupleMenu/styles.ts
var INPUT_COMMON_PROPS = {
  bgColor: "#FEFEFE",
  border: "1px solid #E6DBD9",
  borderRadius: "8px",
  fontSize: "14px",
  size: "sm",
  mb: "8px"
};
var LABEL_COMMON_PROPS = {
  fontSize: "12px",
  fontWeight: "500",
  mb: "4px"
};

// src/components/SimulationFont/CoupleConfig/CoupleMenu/CoupleMenu.tsx
import { jsx as jsx18, jsxs as jsxs15 } from "react/jsx-runtime";
var CoupleMenu = () => {
  const { coupleForm, onSetCouple } = useImaginationRoom();
  const handleChange = (key, event) => {
    const value = event.target.value;
    onSetCouple(__spreadProps(__spreadValues({}, coupleForm), { [key]: value }));
  };
  return /* @__PURE__ */ jsxs15(Box15, { children: [
    /* @__PURE__ */ jsx18(Text15, __spreadProps(__spreadValues({}, LABEL_COMMON_PROPS), { children: "Nama Pengantin:" })),
    /* @__PURE__ */ jsx18(
      Input4,
      __spreadProps(__spreadValues({}, INPUT_COMMON_PROPS), {
        value: coupleForm.coupleName,
        onChange: (e) => handleChange("coupleName", e),
        placeholder: "Bride & Groom"
      })
    ),
    /* @__PURE__ */ jsx18(Text15, __spreadProps(__spreadValues({}, LABEL_COMMON_PROPS), { children: "Nama Lengkap Bride:" })),
    /* @__PURE__ */ jsx18(
      Input4,
      __spreadProps(__spreadValues({}, INPUT_COMMON_PROPS), {
        value: coupleForm.brideFullName,
        onChange: (e) => handleChange("brideFullName", e),
        placeholder: "Bride Fullname"
      })
    ),
    /* @__PURE__ */ jsx18(Text15, __spreadProps(__spreadValues({}, LABEL_COMMON_PROPS), { children: "Nama Bride:" })),
    /* @__PURE__ */ jsx18(
      Input4,
      __spreadProps(__spreadValues({}, INPUT_COMMON_PROPS), {
        value: coupleForm.brideName,
        onChange: (e) => handleChange("brideName", e),
        placeholder: "Bride"
      })
    ),
    /* @__PURE__ */ jsx18(Text15, __spreadProps(__spreadValues({}, LABEL_COMMON_PROPS), { children: "Nama Lengkap Groom:" })),
    /* @__PURE__ */ jsx18(
      Input4,
      __spreadProps(__spreadValues({}, INPUT_COMMON_PROPS), {
        value: coupleForm.groomFullName,
        onChange: (e) => handleChange("groomFullName", e),
        placeholder: "Groom Fullname"
      })
    ),
    /* @__PURE__ */ jsx18(Text15, __spreadProps(__spreadValues({}, LABEL_COMMON_PROPS), { children: "Nama Groom:" })),
    /* @__PURE__ */ jsx18(
      Input4,
      __spreadProps(__spreadValues({}, INPUT_COMMON_PROPS), {
        value: coupleForm.groomName,
        onChange: (e) => handleChange("groomName", e),
        placeholder: "Groom"
      })
    )
  ] });
};
var CoupleMenu_default = CoupleMenu;

// src/components/SimulationFont/CoupleConfig/CoupleConfig.tsx
import { jsx as jsx19, jsxs as jsxs16 } from "react/jsx-runtime";
var CoupleConfig = () => {
  const [isAuth, setIsAuth] = useState14(false);
  const [adminPassword, setAdminPassword] = useState14("");
  const validatePassword = () => {
    if (adminPassword === COUPLE_ADMIN_PASSWORD) {
      setIsAuth(true);
      setLocalItem(COUPLE_LS_KEY, adminPassword);
      return true;
    }
    return false;
  };
  useEffect4(() => {
    const prevPassword = getLocalItem(COUPLE_LS_KEY);
    if (prevPassword === COUPLE_ADMIN_PASSWORD) {
      setIsAuth(true);
    }
  }, []);
  return /* @__PURE__ */ jsx19(Accordion, { allowToggle: true, mt: "-1px", borderColor: "rgba(85, 85, 38, 0.111)", borderTop: "transparent", children: /* @__PURE__ */ jsxs16(AccordionItem, { children: [
    /* @__PURE__ */ jsxs16(AccordionButton, { children: [
      /* @__PURE__ */ jsx19(Box16, { as: "span", flex: "1", textAlign: "left", children: /* @__PURE__ */ jsx19(Text16, { fontSize: "14px", children: "Admin Menu" }) }),
      /* @__PURE__ */ jsx19(AccordionIcon, {})
    ] }),
    /* @__PURE__ */ jsx19(AccordionPanel, { pb: 4, children: isAuth ? /* @__PURE__ */ jsx19(CoupleMenu_default, {}) : /* @__PURE__ */ jsx19(
      CoupleAuth_default,
      {
        adminPassword,
        onSetAdminPassword: setAdminPassword,
        onValidateAdminPassword: validatePassword
      }
    ) })
  ] }) });
};
var CoupleConfig_default = CoupleConfig;

// src/components/SimulationFont/SimulationFont.tsx
import { Fragment as Fragment9, jsx as jsx20, jsxs as jsxs17 } from "react/jsx-runtime";
var SimulationFont = ({ isShowDetailContent }) => {
  const [resetSignal, setResetSignal] = useState15(0);
  const { fontForm, isFontListLoading, isFontRecommendationLoading, onSetFont, onHandleResetFont } = useImaginationRoom();
  const { isOpen, onOpen, onClose } = useDisclosure8();
  const toast = useToast7();
  const onHandleReset = () => {
    try {
      onHandleResetFont();
      setResetSignal(Date.now());
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx20(
          CustomToast_default,
          {
            status: "success",
            title: "Sukses!",
            desc: "Font berhasil direset.",
            id,
            onClose: onClose2
          }
        )
      });
    } catch (e) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx20(
          CustomToast_default,
          {
            status: "error",
            title: "Oops!",
            desc: "Terjadi kesalahan. Mohon muat ulang browser Anda atau coba lagi nanti.",
            id,
            onClose: onClose2
          }
        )
      });
    }
    onClose();
  };
  const onClickMenu = (idContent) => {
    if (idContent === "cover_section") {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx20(
          CustomToast_default,
          {
            status: "info",
            title: "Umm..",
            desc: "Konten ini berada di cover.",
            id,
            onClose: onClose2
          }
        )
      });
      return;
    }
    if (!isShowDetailContent) {
      toast({
        position: "top",
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx20(
          CustomToast_default,
          {
            status: "info",
            title: "Tunggu..",
            desc: "Buka undangan terlebih dahulu",
            id,
            onClose: onClose2
          }
        )
      });
      return;
    }
    try {
      scroller2.scrollTo(idContent, {
        duration: 1500,
        delay: 100,
        smooth: true
      });
    } catch (e) {
      toast({
        duration: 5e3,
        render: ({ onClose: onClose2, id }) => /* @__PURE__ */ jsx20(
          CustomToast_default,
          {
            status: "error",
            title: "Oops!",
            desc: "Terjadi kesalahan. Mohon muat ulang browser Anda atau coba lagi nanti.",
            id,
            onClose: onClose2
          }
        )
      });
    }
    return;
  };
  if (isFontListLoading || isFontRecommendationLoading) {
    return /* @__PURE__ */ jsx20(Center7, { h: "100%", w: "100%", children: /* @__PURE__ */ jsx20(CircularProgress2, { isIndeterminate: true, color: "#a1425c", size: "48px" }) });
  }
  return /* @__PURE__ */ jsxs17(Fragment9, { children: [
    /* @__PURE__ */ jsxs17(Box17, __spreadProps(__spreadValues({}, SIMULATION_CONTAINER_PROPS), { children: [
      /* @__PURE__ */ jsxs17(Box17, __spreadProps(__spreadValues({}, SIMULATION_HEADER_CONTAINER), { children: [
        /* @__PURE__ */ jsx20(Text17, __spreadProps(__spreadValues({}, SIMULATION_HEADER_TEXT), { children: "Simulasi Font" })),
        /* @__PURE__ */ jsx20(Button14, __spreadProps(__spreadValues({}, SIMULATION_BUTTON_SECONDARY), { onClick: onOpen, children: "Reset Font" }))
      ] })),
      /* @__PURE__ */ jsxs17(Box17, __spreadProps(__spreadValues({}, SIMULATION_BODY_CONTAINER), { children: [
        fontForm.map((fontData) => /* @__PURE__ */ jsx20(
          FontEditor_default,
          {
            fontData,
            onChange: (newFontValue) => onSetFont(newFontValue),
            onScrollTo: () => onClickMenu(fontData.fontSectionId)
          },
          `${fontData.fontCSS}-${resetSignal}`
        )),
        /* @__PURE__ */ jsx20(CoupleConfig_default, {})
      ] }))
    ] })),
    /* @__PURE__ */ jsx20(
      ConfirmationAlert_default,
      {
        isOpenAlert: isOpen,
        onCloseAlert: onClose,
        onConfirm: onHandleReset,
        title: "Reset Font",
        desc: "Apakah Anda yakin? Anda tidak dapat membatalkan tindakan ini setelahnya."
      }
    )
  ] });
};
var SimulationFont_default = SimulationFont;

// src/components/SimulationDrawer.tsx
import { jsx as jsx21, jsxs as jsxs18 } from "react/jsx-runtime";
function SimulationDrawer({
  isShowDetailContent,
  disableColor,
  disableFonts,
  disableImage,
  disableConfig,
  imageHelperLink,
  assetsHelperLink
}) {
  const [drawerState, setDrawerState] = useState16(DRAWER_STATE.image);
  const [isTransitioning, setIsTransitioning] = useState16(false);
  const { isOpen: isOpenMainDrawer, onToggle: onToggleMainDrawer } = useDisclosure9();
  const handleToggleDrawer = (drawerName) => {
    if (drawerState !== drawerName) {
      setIsTransitioning(true);
      setDrawerState(drawerName);
      setTimeout(() => {
        setIsTransitioning(false);
      }, 350);
    }
  };
  return /* @__PURE__ */ jsxs18(Portal, { children: [
    /* @__PURE__ */ jsx21(Helmet, { children: /* @__PURE__ */ jsx21(
      "link",
      {
        href: "https://fonts.googleapis.com/css2?family=Aboreto&family=Abril+Fatface&family=Arima:wght@100..700&family=Bad+Script&family=Bebas+Neue&family=Caudex:ital,wght@0,400;0,700;1,400;1,700&family=Charmonman:wght@400;700&family=Cinzel+Decorative:wght@400;700;900&family=Clicker+Script&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Cormorant+Upright:wght@300;400;500;600;700&family=Dawning+of+a+New+Day&family=Delius+Swash+Caps&family=Della+Respira&family=Forum&family=Gabriela&family=Gilda+Display&family=Glass+Antiqua&family=Grand+Hotel&family=Italiana&family=Josefin+Sans:ital,wght@0,100..700;1,100..700&family=Josefin+Slab:ital,wght@0,100..700;1,100..700&family=Jost:ital,wght@0,100..900;1,100..900&family=Lancelot&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Lobster+Two:ital,wght@0,400;0,700;1,400;1,700&family=Lora:ital,wght@0,400..700;1,400..700&family=Marcellus&family=Marcellus+SC&family=Mate+SC&family=Mate:ital@0;1&family=Meddon&family=Milonga&family=Miniver&family=Monsieur+La+Doulaise&family=MonteCarlo&family=Montserrat:ital,wght@0,100..900;1,100..900&family=MuseoModerno:ital,wght@0,100..900;1,100..900&family=Newsreader:ital,opsz,wght@0,6..72,200..800;1,6..72,200..800&family=Noto+Serif:ital,wght@0,100..900;1,100..900&family=Old+Standard+TT:ital,wght@0,400;0,700;1,400&family=Oswald:wght@200..700&family=Palanquin:wght@100;200;300;400;500;600;700&family=Petit+Formal+Script&family=Philosopher:ital,wght@0,400;0,700;1,400;1,700&family=Pinyon+Script&family=Playfair+Display:ital,wght@0,400..900;1,400..900&family=Poiret+One&family=Pompiere&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Prata&family=Quattrocento:wght@400;700&family=Raleway:ital,wght@0,100..900;1,100..900&family=Ranga:wght@400;700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Rouge+Script&family=Sofia&family=Sorts+Mill+Goudy:ital@0;1&family=Tangerine:wght@400;700&family=Tenor+Sans&family=Vibur&family=Ysabeau+Infant:ital,wght@0,1..1000;1,1..1000&display=swap",
        rel: "stylesheet"
      }
    ) }),
    /* @__PURE__ */ jsxs18(
      Slide,
      {
        direction: "bottom",
        in: isOpenMainDrawer,
        style: {
          bottom: isOpenMainDrawer ? "16px" : "52px",
          position: "fixed",
          transform: "translate(calc(50vw - 50%))",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          justifySelf: "center",
          width: "300px",
          left: 0,
          zIndex: 3,
          margin: "0 auto"
        },
        children: [
          /* @__PURE__ */ jsx21(
            Collapse,
            {
              in: drawerState !== DRAWER_STATE.idle && !isTransitioning,
              style: { zIndex: 3, paddingTop: "16px" },
              children: /* @__PURE__ */ jsxs18(
                Box18,
                {
                  h: "516px",
                  w: "300px",
                  bg: "#FAF8F4",
                  borderTopRadius: "md",
                  borderWidth: "1px",
                  borderColor: "#dee2e6",
                  borderBottom: "none",
                  position: "relative",
                  fontFamily: "Poppins",
                  children: [
                    /* @__PURE__ */ jsx21(Center8, { position: "fixed", top: "0", w: "100%", zIndex: 4, children: /* @__PURE__ */ jsx21(
                      Button15,
                      __spreadProps(__spreadValues({}, SIMULATION_BUTTON_PRIMARY), {
                        zIndex: 4,
                        onClick: onToggleMainDrawer,
                        h: "32px",
                        leftIcon: /* @__PURE__ */ jsx21(LuPalette, { size: 16, color: "white" }),
                        borderRadius: "5px",
                        fontWeight: 400,
                        children: "Imagination Room"
                      })
                    ) }),
                    isOpenMainDrawer && /* @__PURE__ */ jsx21(
                      CloseButton2,
                      {
                        position: "fixed",
                        zIndex: 4,
                        right: "4px",
                        size: "md",
                        onClick: onToggleMainDrawer
                      }
                    ),
                    drawerState === DRAWER_STATE.color && !isTransitioning && !disableColor && /* @__PURE__ */ jsx21(SimulationColor_default, { isShowDetailContent }),
                    drawerState === DRAWER_STATE.image && !isTransitioning && !disableImage && /* @__PURE__ */ jsx21(
                      SimulationImage_default,
                      {
                        imageHelperLink,
                        assetsHelperLink
                      }
                    ),
                    drawerState === DRAWER_STATE.font && !isTransitioning && !disableFonts && /* @__PURE__ */ jsx21(SimulationFont_default, { isShowDetailContent }),
                    drawerState === DRAWER_STATE.config && !isTransitioning && !disableConfig && /* @__PURE__ */ jsx21(SimulationConfig_default, {})
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ jsxs18(
            Box18,
            __spreadProps(__spreadValues({}, DEFAULT_BOX_PROPS), {
              display: "flex",
              borderTopRadius: drawerState !== DRAWER_STATE.idle ? "" : "md",
              borderBottomRadius: !isOpenMainDrawer ? "0" : "md",
              children: [
                !disableColor && /* @__PURE__ */ jsx21(
                  DrawerButton,
                  {
                    buttonState: DRAWER_STATE.color,
                    currentState: drawerState,
                    onUpdate: () => handleToggleDrawer(DRAWER_STATE.color),
                    icon: /* @__PURE__ */ jsx21(LuPalette, { size: 22, color: "#ba5c76" })
                  }
                ),
                !disableImage && /* @__PURE__ */ jsx21(
                  DrawerButton,
                  {
                    buttonState: DRAWER_STATE.image,
                    currentState: drawerState,
                    onUpdate: () => handleToggleDrawer(DRAWER_STATE.image),
                    icon: /* @__PURE__ */ jsx21(LuImage, { size: 22, color: "#ba5c76" })
                  }
                ),
                !disableFonts && /* @__PURE__ */ jsx21(
                  DrawerButton,
                  {
                    buttonState: DRAWER_STATE.font,
                    currentState: drawerState,
                    onUpdate: () => handleToggleDrawer(DRAWER_STATE.font),
                    icon: /* @__PURE__ */ jsx21(LuText, { size: 22, color: "#ba5c76" })
                  }
                ),
                !disableConfig && /* @__PURE__ */ jsx21(
                  DrawerButton,
                  {
                    buttonState: DRAWER_STATE.config,
                    currentState: drawerState,
                    onUpdate: () => handleToggleDrawer(DRAWER_STATE.config),
                    icon: /* @__PURE__ */ jsx21(LuDownload2, { size: 22, color: "#ba5c76" })
                  }
                )
              ]
            })
          )
        ]
      }
    )
  ] });
}
var SimulationDrawer_default = SimulationDrawer;
export {
  ImaginationRoomProvider,
  SimulationDrawer_default as SimulationDrawer,
  useImaginationRoom
};
